<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'60px'}" id="outermost">
    <van-nav-bar :title="companyName" left-text="返回" left-arrow @click-left="checkPageBack" id="topbar"/>
    <div>
      <van-tabs v-model="tabVale" color="#1C75F6" title-active-color="#1C75F6" line-width="65px" :ellipsis="true">
        <van-tab  v-for="item in TABS_LIST" :title="item.title" :name="item.name"/>
      </van-tabs>
    </div>
    <div v-show="tabVale==='basicInfo'" ref="basicMap" id="container" style="width:100%;height:250px"></div>
    <div v-show="tabVale==='basicInfo'" class="toolbar">
      <p style="color:#C8C7CC;font-size:15px;padding: 10px 10px;">当前位置</p>
      <p v-if="lng" style="font-size: 14px;padding: 0 10px;text-align: left;">lng：{{ lng }}，lat：{{ lat }}</p>
      <p style="font-size: 14px;padding: 0 10px;margin-bottom: 14px;">{{ signAddress }}</p>
      <p style="color:#C8C7CC;font-size:15px;padding: 10px 10px;" v-if="form.lng">签到位置</p>
      <p v-if="form.lng" style="font-size: 14px;padding: 0 10px;text-align: left;">lng：{{ form.lng }}，lat：{{ form.lat }}</p>
      <p style="font-size: 14px;padding: 0 10px;margin-bottom: 14px;">{{ form.signAddress }}</p>
      <div style="text-align:center;margin-top:10px;" v-if="!form.lng">
        <van-button v-if="!loaded && !fileds" disabled loading color="#1B75F6" class="signBtn2" loading-text="正在定位..."/>
        <van-button v-if="fileds" @click="getNewIp" color="#1B75F6" class="signBtn2">定位失败，点击重新定位</van-button>
        <van-button v-else-if="loaded && !fileds" @click="getNewIp" color="#1B75F6" class="signBtn2x">重新定位</van-button>&nbsp;
        <van-button v-if="loaded && !fileds " @click="signInAddress" color="#1B75F6" :disabled="isCacheWork==='1'" class="signBtn2x">签到</van-button>
      </div>
      <div style="text-align:center;margin-top:10px;" v-else>
        <van-button v-if="loaded && !fileds" disabled color="#1B75F6" class="signBtn2x">已签到</van-button>
      </div>
    </div>
    <div>
      <van-form class="enterprise-form">
        <div v-show="tabVale==='basicInfo'">
          <div class="title">
            <p style="color:#999999;font-size:14px;padding: 10px 10px;">企业基本信息</p>
          </div>
          <van-field v-model="form.companyAlias" :disabled="isCacheWork==='1'" type="input" input-align="left" placeholder="请输入单位名称" class="custom-field">
            <template #label>
              <div class="custom-label">单位名称</div>
            </template>
          </van-field>
          <van-field v-model="form.companyAddress" :disabled="isCacheWork==='1'" type="input" input-align="left" placeholder="请输入单位地址" class="custom-field">
            <template #label>
              <div class="custom-label">单位地址</div>
            </template>
          </van-field>
          <van-field v-model="form.industryName" :disabled="isCacheWork==='1'" input-align="left" readonly @click="HandleSelectIndustry" placeholder="请选择行业类别" class="custom-field">
            <template #right-icon>
              <van-icon name="arrow"/>
            </template>
            <template #label>
              <div class="custom-label">行业类别</div>
            </template>
          </van-field>
          <van-field v-model="form.thisContact" :disabled="isCacheWork==='1'" type="input" maxlength="25" input-align="left" placeholder="请输入联系人" class="custom-field" label-width="100px">
            <template #label>
              <div class="custom-label">本次企业联系人</div>
            </template>
          </van-field>
          <van-field v-model="form.contactPhone" :disabled="isCacheWork==='1'" type="input" maxlength="25" input-align="left" placeholder="请输入联系电话" class="custom-field" label-width="120px">
            <template #label>
              <div class="custom-label">本次企业联系电话</div>
            </template>
          </van-field>
          <van-field v-model="form.commonCheckUser" :disabled="isCacheWork==='1'" type="input" maxlength="25" input-align="left" placeholder="请输入参与人员" class="custom-field">
            <template #label>
              <div class="custom-label">参与人员</div>
            </template>
          </van-field>
          <van-field name="radio" class="custom-field">
            <template #input>
              <van-radio-group v-model="form.productionStatus" direction="horizontal" :disabled="isCacheWork==='1'" @change="handleProductionStatus" >
                <van-radio name="在建" class="radio-item">在建</van-radio>
                <van-radio name="调试期" class="radio-item">调试期</van-radio>
                <van-radio name="正常生产" class="radio-item">正常生产</van-radio>
                <van-radio name="停产" class="radio-item">停产</van-radio>
                <van-radio name="关闭" class="radio-item">关闭</van-radio>
                <van-radio :name="baseInfo.showMoveOut?'搬迁至'+baseInfo.moveOutName:'搬迁'" class="radio-item" >
                  <div v-if="baseInfo.showMoveOut" style="display: flex; align-items: center; gap: 8px">
                    <span>搬迁至</span>
                    <van-field v-model="baseInfo.moveOutName" :disabled="isCacheWork==='1'" input-align="center" @input="handleChangeRadioName" style="flex: 1; padding: 0; border-bottom: #0C0C0C 1px solid;width: 180px"/>
                  </div>
                  <span v-else>搬迁</span>
                </van-radio>
                <van-radio name="非生产型" class="radio-item" >非生产型</van-radio>
                <van-radio name="其他" class="radio-item" >其他</van-radio>
              </van-radio-group>
            </template>
            <template #label>
              <div class="custom-label">生产情况</div>
            </template>
          </van-field>
          <van-field v-if="PRODUCTION_NORMAL" name="radio" class="custom-field">
            <template #input>
              <van-radio-group v-model="form.isNightProduction" :disabled="isCacheWork==='1'" direction="horizontal">
                <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
              </van-radio-group>
            </template>
            <template #label>
              <div class="custom-label">夜间是否生产</div>
            </template>
          </van-field>
          <van-field v-if="PRODUCTION_NORMAL" name="textarea" class="custom-field">
            <template #input>
              <textarea v-model="form.process" :disabled="isCacheWork==='1'" placeholder="请输入主要生产工艺" style="width: 99%;border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30"/>
            </template>
            <template #label>
              <div class="custom-label">主要生产工艺</div>
            </template>
          </van-field>
          <van-field v-if="PRODUCTION_NORMAL" name="textarea" class="custom-field">
            <template #input>
             <textarea v-model="form.produced" :disabled="isCacheWork==='1'" placeholder="请输入生产产品" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30"/>
            </template>
            <template #label>
              <div class="custom-label">主要产品</div>
            </template>
          </van-field>
          <van-popup v-model="showSelectIndustry" class="select-industry-popup" position="right" :style="{ height: '100%',width: '100%'}" :close-on-click-overlay="false" >
            <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'60px'}" id="outermost">
              <van-nav-bar class="selectIndustryBarTitle" title="行业类型" left-arrow id="selectIndustryBar" @click-left="handleClearSelectIndusTry">
                <template #right>
                  <van-button type="info" size="small" style="border-radius: 5px" :disabled="!selectIndustry.selectedName" @click="HandleSelectIndusTryDone" text="完成"/>
                </template>
              </van-nav-bar>
              <van-search v-model="industryName" class="search-style" @input="searchIndustry" placeholder="请输入搜索关键词" />
              <van-cell-group>
                <div v-for="item in selectIndustryList" :key="item.code">
                  <van-cell :title="item.name" :class="{ 'selected-cell': selectIndustry.selectedCode === item.code }" @click="handleSelect(item)">
                    <template #right-icon>
                      <van-icon v-if="selectIndustry.selectedCode === item.code" name="success" color="#07c160" class="check-icon"/>
                    </template>
                  </van-cell>
                </div>
              </van-cell-group>
            </div>
          </van-popup>
        </div>
        <div v-show="tabVale==='envPermit'">
          <van-collapse v-model="envPermitActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>建设项目环境影响评价管理</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.ENV_PERMIT_CHECK_REQUIRE_ONE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.envPermitQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.IMPLEMENTED_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>环评文件及相关手续：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionOneAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('envPermitQuestionOneAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionOneAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionOneAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionOneAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                            v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionOneAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.envPermitQuestionOneAnswer==='已落实'" name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.envPermitQuestionTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.EIA_TYPE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>环评类型：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('envPermitQuestionTwoAnswer') && form.envPermitQuestionOneAnswer==='已落实'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwoAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.envPermitQuestionOneAnswer==='已落实'" name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>建设项目批建相符性</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.ENV_PERMIT_CHECK_REQUIRE_TWO)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.envPermitQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.COHERENCY_TYPE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>实际内容与环保许可文件一致性：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('envPermitQuestionThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item name="3" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>排污许可证申领与执行</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.ENV_PERMIT_CHECK_REQUIRE_THREE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.envPermitQuestionFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.IMPLEMENTED_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>排污许可证申领落实情况：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('envPermitQuestionFourAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.envPermitQuestionFourAnswer==='已落实'" name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.envPermitQuestionFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.POLLUTION_PERMIT_TYPE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>排污许可证类型：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('envPermitQuestionFiveAnswer') && form.envPermitQuestionFourAnswer==='已落实'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionFiveAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item name="4" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>建设项目环境保护“三同时”管理</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.ENV_PERMIT_CHECK_REQUIRE_FOUR)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.envPermitQuestionSixAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.IMPLEMENTED_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>验收文件及相关手续：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionSixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('envPermitQuestionSixAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionSixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionSixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionSixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionSixAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.envPermitQuestionSixAnswer && form.envPermitQuestionSixAnswer!=='豁免'" name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.envPermitQuestionSevenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in getEnvPermitQuestionSevenAnswerList()" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>自主验收是否涉及违法情况：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionSevenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('envPermitQuestionSevenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionSevenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionSevenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionSevenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionSevenAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item name="5" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>企业一企一档建立情况</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.ENV_PERMIT_CHECK_REQUIRE_FIVE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.envPermitQuestionEightAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.FILE_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <van-collapse-item v-if="form.envPermitQuestionEightAnswer==='未建立'" name="6" class="collapse-item-content">
                <template #title>
                  <div class="collapse-item-title">
                    <span>环保手续</span>
                  </div>
                </template>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionNineAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>环评报告文件/批复</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionNineAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionNineAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionNineAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionNineAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionNineAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionNineAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionTenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>非重大变动分析报告</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionTenAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionTenAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTenAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionTenAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionTenAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTenAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionEleventhAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>竣工环保验收报告</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionEleventhAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionEleventhAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionEleventhAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionEleventhAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionEleventhAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionEleventhAnswer')].remark"/>
                  </template>
                </van-field>
              </van-collapse-item>
              <van-collapse-item v-if="form.envPermitQuestionEightAnswer==='未建立'" name="7" class="collapse-item-content">
                <template #title>
                  <div class="collapse-item-title">
                    <span>排污许可</span>
                  </div>
                </template>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionDecemberAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>排污许可证（正本+副本）</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionDecemberAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionDecemberAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionDecemberAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionDecemberAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionDecemberAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionDecemberAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionThirteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>固定污染源排污登记回执/排污登记表</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionThirteenthAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionThirteenthAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionThirteenthAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionThirteenthAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionThirteenthAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionThirteenthAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionFourteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>执行报告</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionFourteenthAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionFourteenthAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionFourteenthAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionFourteenthAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionFourteenthAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionFourteenthAnswer')].remark"/>
                  </template>
                </van-field>
              </van-collapse-item>
              <van-collapse-item v-if="form.envPermitQuestionEightAnswer==='未建立'" name="8" class="collapse-item-content">
                <template #title>
                  <div class="collapse-item-title">
                    <span>自行监测</span>
                  </div>
                </template>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionFifteenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>自行监测方案</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionFifteenAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionFifteenAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionFifteenAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionFifteenAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionFifteenAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionFifteenAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionSixteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>监测报告</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionSixteenthAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionSixteenthAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionSixteenthAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionSixteenthAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionSixteenthAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionSixteenthAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionSeventeenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>在线监测备案材料</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionSeventeenthAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionSeventeenthAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionSeventeenthAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionSeventeenthAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionSeventeenthAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionSeventeenthAnswer')].remark"/>
                  </template>
                </van-field>
              </van-collapse-item>
              <van-collapse-item v-if="form.envPermitQuestionEightAnswer==='未建立'" name="9" class="collapse-item-content">
                <template #title>
                  <div class="collapse-item-title">
                    <span>固体废物</span>
                  </div>
                </template>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionEighteenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>危险废物处置合同/协议</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionEighteenAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionEighteenAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionEighteenAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionEighteenAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionEighteenAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionEighteenAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionNineteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>一般工业固废处置合同/协议</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionNineteenthAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionNineteenthAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionNineteenthAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionNineteenthAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionNineteenthAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionNineteenthAnswer')].remark"/>
                  </template>
                </van-field>
              </van-collapse-item>
              <van-collapse-item v-if="form.envPermitQuestionEightAnswer==='未建立'" name="10" class="collapse-item-content">
                <template #title>
                  <div class="collapse-item-title">
                    <span>应急预案</span>
                  </div>
                </template>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionTwentyAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>环境应急预案及备案</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionTwentyAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionTwentyAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionTwentyAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionTwentyAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionTwentyOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>环境风险评估报告</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionTwentyOneAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionTwentyOneAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyOneAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionTwentyOneAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionTwentyOneAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyOneAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionTwentyTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>应急演练、培训记录</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionTwentyTwoAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionTwentyTwoAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyTwoAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionTwentyTwoAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionTwentyTwoAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyTwoAnswer')].remark"/>
                  </template>
                </van-field>
              </van-collapse-item>
              <van-collapse-item v-if="form.envPermitQuestionEightAnswer==='未建立'" name="11" class="collapse-item-content">
                <template #title>
                  <div class="collapse-item-title">
                    <span>其他</span>
                  </div>
                </template>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionTwentyThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>排水许可证/污水纳管协议</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionTwentyThreeAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionTwentyThreeAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyThreeAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionTwentyThreeAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionTwentyThreeAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyThreeAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionTwentyFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>雨水/污水管网平面布置图</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionTwentyFourAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionTwentyFourAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyFourAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionTwentyFourAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionTwentyFourAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyFourAnswer')].remark"/>
                  </template>
                </van-field>
                <van-field name="radio" class="custom-field" label-width="100%">
                  <template #input>
                    <van-radio-group v-model="form.envPermitQuestionTwentyFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                      <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                    </van-radio-group>
                  </template>
                  <template #label>
                    <div class="custom-label2">
                      <span>企业关停并转证明</span>
                      <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('envPermitQuestionTwentyFiveAnswer')"/>
                    </div>
                  </template>
                </van-field>
                <van-field v-if="isRemarks('envPermitQuestionTwentyFiveAnswer')" name="remarks" class="custom-field-remarks">
                  <template #input>
                    <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyFiveAnswer')].remarkPhotos" multiple
                                  :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'envPermitQuestionTwentyFiveAnswer')" :disabled="isCacheWork==='1'"
                                  :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'envPermitQuestionTwentyFiveAnswer')"/>
                    <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                               v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'envPermitQuestionTwentyFiveAnswer')].remark"/>
                  </template>
                </van-field>
              </van-collapse-item>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='potentialRisks'">
          <van-collapse v-model="potentialRisksActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>环保设备设施及安全隐患排查</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.potentialRisksQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.potentialRisksQuestionOneAnswer==='涉及'" name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>废气处理设备</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.POTENTIAL_RISKS_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.potentialRisksQuestionTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal" @change="handleRisksQuestionNum(1)">
                    <van-radio name="是" class="radio-item">
                      <div v-if="form.potentialRisksQuestionTwoAnswer==='是'" style="display: flex; align-items: center; gap: 8px">
                        <span>是 （数量：</span>
                        <van-field v-model="form.potentialRisksQuestionTwoAnswerNum" :disabled="isCacheWork==='1'" input-align="center" placeholder="填写" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" inputmode="numeric" style="flex: 1; padding: 0; border-bottom: #0C0C0C 1px solid;width: 60px"/>
                        <span> ）</span>
                      </div>
                      <span v-else>是</span>
                    </van-radio>
                    <van-radio name="否" class="radio-item">否</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有脱硫脱硝装置：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('potentialRisksQuestionTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('potentialRisksQuestionTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'potentialRisksQuestionTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'potentialRisksQuestionTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionTwoAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.potentialRisksQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal" @change="handleRisksQuestionNum(2)">
                    <van-radio name="是" class="radio-item">
                      <div v-if="form.potentialRisksQuestionThreeAnswer==='是'" style="display: flex; align-items: center; gap: 8px">
                        <span>是 （数量：</span>
                        <van-field v-model="form.potentialRisksQuestionThreeAnswerNum" :disabled="isCacheWork==='1'" input-align="center" placeholder="填写" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" inputmode="numeric" style="flex: 1; padding: 0; border-bottom: #0C0C0C 1px solid;width: 60px"/>
                        <span> ）</span>
                      </div>
                      <span v-else>是</span>
                    </van-radio>
                    <van-radio name="否" class="radio-item">否</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有VOCs回收装置：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('potentialRisksQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('potentialRisksQuestionThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'potentialRisksQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'potentialRisksQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.potentialRisksQuestionFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal" @change="handleRisksQuestionNum(3)">
                    <van-radio name="是" class="radio-item">
                      <div v-if="form.potentialRisksQuestionFourAnswer==='是'" style="display: flex; align-items: center; gap: 8px">
                        <span>是 （数量：</span>
                        <van-field v-model="form.potentialRisksQuestionFourAnswerNum" :disabled="isCacheWork==='1'" input-align="center" placeholder="填写" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" inputmode="numeric" style="flex: 1; padding: 0; border-bottom: #0C0C0C 1px solid;width: 60px"/>
                        <span> ）</span>
                      </div>
                      <span v-else>是</span>
                    </van-radio>
                    <van-radio name="否" class="radio-item">否</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有粉尘治理装置：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('potentialRisksQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('potentialRisksQuestionFourAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'potentialRisksQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'potentialRisksQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.potentialRisksQuestionFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal" @change="handleRisksQuestionNum(4)">
                    <van-radio name="是" class="radio-item">
                      <div v-if="form.potentialRisksQuestionFiveAnswer==='是'" style="display: flex; align-items: center; gap: 8px">
                        <span>是 （数量：</span>
                        <van-field v-model="form.potentialRisksQuestionFiveAnswerNum" :disabled="isCacheWork==='1'" input-align="center" placeholder="填写" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" inputmode="numeric" style="flex: 1; padding: 0; border-bottom: #0C0C0C 1px solid;width: 60px"/>
                        <span> ）</span>
                      </div>
                      <span v-else>是</span>
                    </van-radio>
                    <van-radio name="否" class="radio-item">否</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有蓄热式焚烧炉：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('potentialRisksQuestionFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('potentialRisksQuestionFiveAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'potentialRisksQuestionFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'potentialRisksQuestionFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionFiveAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.potentialRisksQuestionOneAnswer==='涉及'" name="3" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>废水处理设备</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.POTENTIAL_RISKS_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.potentialRisksQuestionSixAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有污水处理设施：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('potentialRisksQuestionSixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('potentialRisksQuestionSixAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionSixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'potentialRisksQuestionSixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'potentialRisksQuestionSixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionSixAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.potentialRisksQuestionOneAnswer==='涉及'" name="4" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>生态环境领域有限空间</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.POTENTIAL_RISKS_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.potentialRisksQuestionSevenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有生态环境领域有限空间：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('potentialRisksQuestionSevenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('potentialRisksQuestionSevenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionSevenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'potentialRisksQuestionSevenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'potentialRisksQuestionSevenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionSevenAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.potentialRisksQuestionOneAnswer==='涉及'" name="5" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>危险废物贮存间</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.POTENTIAL_RISKS_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.potentialRisksQuestionEightAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有危险废物贮存间：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('potentialRisksQuestionEightAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('potentialRisksQuestionEightAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionEightAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'potentialRisksQuestionEightAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'potentialRisksQuestionEightAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionEightAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.potentialRisksQuestionOneAnswer==='涉及'" name="6" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>移动探伤放射源</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.POTENTIAL_RISKS_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.potentialRisksQuestionNineAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有移动探伤放射源：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('potentialRisksQuestionNineAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('potentialRisksQuestionNineAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionNineAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'potentialRisksQuestionNineAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'potentialRisksQuestionNineAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'potentialRisksQuestionNineAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='proWasteGas'">
          <van-collapse v-model="proWasteGasActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>生产废气</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.proWasteGasQuestionOneAnswer==='涉及'" name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>主要污染物排放情况及设施设备管理</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.PRO_WASTE_GAS_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="textarea" class="custom-field" label-width="100%">
                <template #input>
                  <textarea class="radio-item" v-model="form.proWasteGasQuestionTwoAnswer" :disabled="isCacheWork==='1'" placeholder="请输入" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30"/>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废气产生工段：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionTwoAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.proWasteGasQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item" shape="square" v-for="(item, index) in PROTOCOL.WASTE_GAS_POLLUTION_FACTORS" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废气主要污染因子：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>收集处理设施是否符合环评要求：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionFourAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求设置废气处理设施：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionFiveAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionFiveAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.proWasteGasQuestionFiveAnswer==='是'" name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.proWasteGasQuestionSixAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item" shape="square" v-for="(item, index) in PROTOCOL.WASTE_GAS_TREATMENT_PROCESS" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废气处理设施主要处理工艺：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionSixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionSixAnswer') && form.proWasteGasQuestionFiveAnswer==='是'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionSixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionSixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionSixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionSixAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.proWasteGasQuestionFiveAnswer==='是'" name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionSevenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废气处理设施是否正常使用：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionSevenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionSevenAnswer') && form.proWasteGasQuestionFiveAnswer==='是'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionSevenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionSevenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionSevenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionSevenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.proWasteGasQuestionFiveAnswer==='是'" name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionEightAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求制定管理台账：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionEightAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionEightAnswer') && form.proWasteGasQuestionFiveAnswer==='是'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionEightAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionEightAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionEightAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionEightAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionNineAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废气排放是否涉及无组织：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionNineAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionNineAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionNineAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionNineAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionNineAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionNineAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionTenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>排放口高度是否满足要求：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionTenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionTenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionTenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionTenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionTenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionTenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionEleventhAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否规范设置排口标识：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionEleventhAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionEleventhAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionEleventhAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionEleventhAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionEleventhAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionEleventhAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionDecemberAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>排放口是否设置监测采样口：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionDecemberAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionDecemberAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionDecemberAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionDecemberAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionDecemberAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionDecemberAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.proWasteGasQuestionDecemberAnswer==='是'" name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionThirteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>采样口位置及大小是否规范：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionThirteenthAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionThirteenthAnswer') && form.proWasteGasQuestionDecemberAnswer==='是'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionThirteenthAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionThirteenthAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionThirteenthAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionThirteenthAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionFourteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否安装采样平台：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionFourteenthAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionFourteenthAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionFourteenthAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionFourteenthAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionFourteenthAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionFourteenthAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.proWasteGasQuestionFourteenthAnswer==='是'" name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteGasQuestionFifteenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>采样平台是否符合相应规范要求：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteGasQuestionFifteenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteGasQuestionFifteenAnswer') && form.proWasteGasQuestionFourteenthAnswer==='是'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionFifteenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteGasQuestionFifteenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteGasQuestionFifteenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteGasQuestionFifteenAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='proWasteWater'">
          <van-collapse v-model="proWasteWaterActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>生产废水</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.proWasteWaterQuestionOneAnswer==='涉及'" name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>主要污染物排放情况及设施设备管理</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.PRO_WASTE_WATER_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="textarea" class="custom-field" label-width="100%">
                <template #input>
                  <textarea class="radio-item" v-model="form.proWasteWaterQuestionTwoAnswer" :disabled="isCacheWork==='1'" placeholder="请输入" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30"/>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废水产生工段：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionTwoAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否涉及一类污染物：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.proWasteWaterQuestionThreeAnswer==='是'" name="textarea" class="custom-field" label-width="100%">
                <template #input>
                  <textarea class="radio-item" v-model="form.proWasteWaterQuestionFourAnswer" :disabled="isCacheWork==='1'" placeholder="请输入" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30"/>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>如涉及，涉一类因子：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionFourAnswer') && form.proWasteWaterQuestionThreeAnswer==='是'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>收集处理设施是否符合环评要求：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionFiveAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionFiveAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionSixAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求设置废水处理设施：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionSixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionSixAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionSixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionSixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionSixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionSixAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.proWasteWaterQuestionSixAnswer==='是'" name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.proWasteWaterQuestionSevenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item-other" shape="square" v-for="(item, index) in PROTOCOL.WASTEWATER_TREATMENT_PROCESS" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                    <van-field v-if="!!(form.proWasteWaterQuestionSevenAnswer && form.proWasteWaterQuestionSevenAnswer.some(o => o === '其他'))" input-align="center"
                               v-model="form.proWasteWaterQuestionSevenAnswerOther" :disabled="isCacheWork==='1'" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 70px" placeholder="填写"/>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废水处理设施主要工艺：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionSevenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionSevenAnswer') && form.proWasteWaterQuestionSixAnswer==='是'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionSevenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionSevenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionSevenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionSevenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.proWasteWaterQuestionSixAnswer==='是'" name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionEightAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废水处理设施是否正常使用：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionEightAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionEightAnswer') && form.proWasteWaterQuestionSixAnswer==='是'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionEightAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionEightAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionEightAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionEightAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.proWasteWaterQuestionSixAnswer==='是'" name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionNineAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求制定管理台账：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionNineAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionNineAnswer') && form.proWasteWaterQuestionSixAnswer==='是'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionNineAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionNineAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionNineAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionNineAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionTenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否雨污分流：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionTenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionTenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionTenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionTenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionTenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionTenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionEleventhAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废水是否按规定纳管：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionEleventhAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionEleventhAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionEleventhAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionEleventhAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionEleventhAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionEleventhAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionDecemberAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否存在其他污水漫流、跑冒滴漏现象：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionDecemberAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionDecemberAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionDecemberAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionDecemberAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionDecemberAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionDecemberAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionThirteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>排放口是否符合相应规范要求：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionThirteenthAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionThirteenthAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionThirteenthAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionThirteenthAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionThirteenthAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionThirteenthAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionFourteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否规范设置排放口标识：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionFourteenthAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionFourteenthAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionFourteenthAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionFourteenthAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionFourteenthAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionFourteenthAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionFifteenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否设有采样口：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionFifteenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionFifteenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionFifteenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionFifteenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionFifteenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionFifteenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.proWasteWaterQuestionFifteenAnswer==='是'" name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.proWasteWaterQuestionSixteenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>采样口是否规范：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionSixteenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionSixteenAnswer') && form.proWasteWaterQuestionFifteenAnswer==='是'" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionSixteenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionSixteenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionSixteenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionSixteenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.proWasteWaterQuestionSeventeenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item" shape="square" v-for="(item, index) in PROTOCOL.WASTEWATER_DISCHARGE" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废水最终排放形式：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('proWasteWaterQuestionSeventeenthAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('proWasteWaterQuestionSeventeenthAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionSeventeenthAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'proWasteWaterQuestionSeventeenthAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'proWasteWaterQuestionSeventeenthAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'proWasteWaterQuestionSeventeenthAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='chemSolidWaste'">
          <van-collapse v-model="chemSolidWasteActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>危险化学品</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>一般工业废物</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item name="3" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>危险废物</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.chemSolidWasteQuestionOneAnswer==='涉及'" name="4" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>危险化学品</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.CHEM_SOLID_WASTE_CHECK_REQUIRE_ONE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求制定管理台账：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionFourAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有应急管理制度及相应设施：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionFiveAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionFiveAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionSixAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否设置固定的贮存场所：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionSixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionSixAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionSixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionSixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionSixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionSixAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionSevenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否设置防渗漏措施：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionSevenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionSevenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionSevenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionSevenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionSevenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionSevenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionEightAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否设置泄漏报警装置：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionEightAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionEightAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionEightAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionEightAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionEightAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionEightAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.chemSolidWasteQuestionTwoAnswer==='涉及'" name="5" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>一般工业固体废物</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.CHEM_SOLID_WASTE_CHECK_REQUIRE_TWO)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionNineAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>种类及数量是否与环评一致：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionNineAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionNineAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionNineAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionNineAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionNineAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionNineAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-model="form.chemSolidWasteQuestionTenAnswer" :disabled="isCacheWork==='1'" type="input" input-align="left" placeholder="请输入处置单位" class="custom-field" label-width="100%">
                <template #label>
                  <div class="custom-label2" style="margin-bottom: 5px">
                    <span>处置单位：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionEleventhAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求制定管理制度：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionEleventhAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionEleventhAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionEleventhAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionEleventhAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionEleventhAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionEleventhAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionDecemberAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求制定管理计划：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionDecemberAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionDecemberAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionDecemberAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionDecemberAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionDecemberAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionDecemberAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionThirteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求制定管理台账：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionThirteenthAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionThirteenthAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirteenthAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionThirteenthAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionThirteenthAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirteenthAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionFourteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否涉及跨省转移备案：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionFourteenthAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionFourteenthAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionFourteenthAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionFourteenthAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionFourteenthAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionFourteenthAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionFifteenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否收集下游处置单位的资质材料：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionFifteenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionFifteenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionFifteenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionFifteenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionFifteenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionFifteenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionSixteenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否设置固定的贮存场所：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionSixteenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionSixteenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionSixteenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionSixteenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionSixteenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionSixteenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionSeventeenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否设置标识：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionSeventeenthAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionSeventeenthAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionSeventeenthAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionSeventeenthAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionSeventeenthAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionSeventeenthAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionEighteenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有其他垃圾混入：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionEighteenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionEighteenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionEighteenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionEighteenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionEighteenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionEighteenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionNineteenthAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否分类分区贮存：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionNineteenthAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionNineteenthAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionNineteenthAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionNineteenthAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionNineteenthAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionNineteenthAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwentyAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否设置防扬散、防流失、防泄漏措施：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTwentyAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTwentyAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTwentyAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTwentyAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwentyOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否签署一般工业固废处理合同：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTwentyOneAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTwentyOneAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyOneAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTwentyOneAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTwentyOneAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyOneAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwentyTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal" @change="handleRisksQuestionNum(5)">
                    <van-radio name="是" class="radio-item">
                      <div v-if="form.chemSolidWasteQuestionTwentyTwoAnswer==='是'" style="display: flex; align-items: center; gap: 8px">
                        <span>是 （处置单位：</span>
                        <van-field v-model="form.chemSolidWasteQuestionTwentyTwoAnswerUnit" :disabled="isCacheWork==='1'" input-align="center" placeholder="单位名称" style="flex: 1; padding: 0; border-bottom: #0C0C0C 1px solid;width: 180px"/>
                        <span> ）</span>
                      </div>
                      <span v-else>是</span>
                    </van-radio>
                    <van-radio name="否" class="radio-item">否</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否明确最终处置单位：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTwentyTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTwentyTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTwentyTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTwentyTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyTwoAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.chemSolidWasteQuestionThreeAnswer==='涉及'" name="6" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>危险废物</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.CHEM_SOLID_WASTE_CHECK_REQUIRE_THREE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwentyThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>种类及数量是否与环评一致：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTwentyThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTwentyThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTwentyThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTwentyThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwentyFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求制定管理制度：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTwentyFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTwentyFourAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTwentyFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTwentyFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwentyFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求制定管理计划：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTwentyFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTwentyFiveAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTwentyFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTwentyFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyFiveAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwentySixAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按要求制定管理台账：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTwentySixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTwentySixAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentySixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTwentySixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTwentySixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentySixAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwentySevenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否涉及跨省转移备案：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTwentySevenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTwentySevenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentySevenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTwentySevenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTwentySevenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentySevenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwentyEightAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否收集下游处置单位的资质材料：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTwentyEightAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTwentyEightAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyEightAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTwentyEightAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTwentyEightAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyEightAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionTwentyNineAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否设置固定的贮存场所：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionTwentyNineAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionTwentyNineAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyNineAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionTwentyNineAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionTwentyNineAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionTwentyNineAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionThirtyAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否设置标识标签：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionThirtyAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionThirtyAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionThirtyAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionThirtyAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionThirtyOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有其他垃圾混入：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionThirtyOneAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionThirtyOneAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyOneAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionThirtyOneAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionThirtyOneAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyOneAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionThirtyTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否分类分区贮存：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionThirtyTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionThirtyTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionThirtyTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionThirtyTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyTwoAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionThirtyThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否设置防扬散、防流失、防泄漏措施：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionThirtyThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionThirtyThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionThirtyThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionThirtyThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionThirtyFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>危废暂存间是否规范：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionThirtyFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionThirtyFourAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionThirtyFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionThirtyFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionThirtyFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否自行处置利用危废：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionThirtyFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionThirtyFiveAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionThirtyFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionThirtyFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtyFiveAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionThirtySixAnswer" :disabled="isCacheWork==='1'" direction="horizontal" @change="handleRisksQuestionNum(6)">
                    <van-radio name="是" class="radio-item">
                      <div v-if="form.chemSolidWasteQuestionThirtySixAnswer==='是'" style="display: flex; align-items: center; gap: 8px">
                        <span>是 （处置去向：</span>
                        <van-field v-model="form.chemSolidWasteQuestionThirtySixAnswerGo" :disabled="isCacheWork==='1'" input-align="center" placeholder="填写处置去向"
                                   style="flex: 1; padding: 0; border-bottom: #0C0C0C 1px solid;width: 180px"/>
                        <span> ）</span>
                      </div>
                      <span v-else>是</span>
                    </van-radio>
                    <van-radio name="否" class="radio-item">否</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否签订危废处置合同：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionThirtySixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionThirtySixAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtySixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionThirtySixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionThirtySixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtySixAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.chemSolidWasteQuestionThirtySevenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>处置单位是否有资质：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('chemSolidWasteQuestionThirtySevenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('chemSolidWasteQuestionThirtySevenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtySevenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'chemSolidWasteQuestionThirtySevenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'chemSolidWasteQuestionThirtySevenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'chemSolidWasteQuestionThirtySevenAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='soilGroundwater'">
          <van-collapse v-model="soilGroundwaterActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>土壤和地下水</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.soilGroundwaterQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.soilGroundwaterQuestionOneAnswer==='涉及'" name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>土壤和地下水防治</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.SOLID_GROUND_WATER_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.soilGroundwaterQuestionTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否存在土壤地下水安全隐患：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('soilGroundwaterQuestionTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('soilGroundwaterQuestionTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'soilGroundwaterQuestionTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'soilGroundwaterQuestionTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'soilGroundwaterQuestionTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'soilGroundwaterQuestionTwoAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.soilGroundwaterQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否储存有毒有害物质的地下储罐：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('soilGroundwaterQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('soilGroundwaterQuestionThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'soilGroundwaterQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'soilGroundwaterQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'soilGroundwaterQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'soilGroundwaterQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.soilGroundwaterQuestionFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO_OR_NOC" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>涉及拆除设施设备或建筑构筑物的，是否采取相应的土壤污染防治措施：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('soilGroundwaterQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('soilGroundwaterQuestionFourAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'soilGroundwaterQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'soilGroundwaterQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'soilGroundwaterQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'soilGroundwaterQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='selfMonitor'">
          <van-collapse v-model="selfMonitorActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>自行监测</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.selfMonitorQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.selfMonitorQuestionOneAnswer==='涉及'" name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>自行监测开展情况</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.SELF_MONITOR_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.selfMonitorQuestionTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.MONITOR_LAUNCH_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>自行监测开展情况：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('selfMonitorQuestionTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('selfMonitorQuestionTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'selfMonitorQuestionTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'selfMonitorQuestionTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'selfMonitorQuestionTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'selfMonitorQuestionTwoAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.selfMonitorQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>监测结果是否达标：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('selfMonitorQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('selfMonitorQuestionThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'selfMonitorQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'selfMonitorQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'selfMonitorQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'selfMonitorQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.selfMonitorQuestionFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>第三方监测单位是否具有相应资质：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('selfMonitorQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('selfMonitorQuestionFourAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'selfMonitorQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'selfMonitorQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'selfMonitorQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'selfMonitorQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='onlineMonitor'">
          <van-collapse v-model="onlineMonitorActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>在线监控</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.onlineMonitorQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.onlineMonitorQuestionOneAnswer==='涉及'" name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>自动监控设备运行情况</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.ONLINE_MONITOR_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.onlineMonitorQuestionTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item" shape="square" v-for="(item, index) in PROTOCOL.MONITOR_OUTLET_TYPE" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>在线监测装置监测排口类型：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('onlineMonitorQuestionTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('onlineMonitorQuestionTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'onlineMonitorQuestionTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'onlineMonitorQuestionTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'onlineMonitorQuestionTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'onlineMonitorQuestionTwoAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.onlineMonitorQuestionTwoAnswer?form.onlineMonitorQuestionTwoAnswer.some(o => o === '废水'):false" name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.onlineMonitorQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item" shape="square" v-for="(item, index) in PROTOCOL.WASTEWATER_FACTORS" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废水：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('onlineMonitorQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('onlineMonitorQuestionThreeAnswer') && form.onlineMonitorQuestionTwoAnswer?form.onlineMonitorQuestionTwoAnswer.some(o => o === '废水'):false" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'onlineMonitorQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'onlineMonitorQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'onlineMonitorQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'onlineMonitorQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.onlineMonitorQuestionTwoAnswer?form.onlineMonitorQuestionTwoAnswer.some(o => o === '废气'):false" name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.onlineMonitorQuestionFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item" shape="square" v-for="(item, index) in PROTOCOL.WASTE_GAS_FACTORS" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>废气：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('onlineMonitorQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('onlineMonitorQuestionFourAnswer') && form.onlineMonitorQuestionTwoAnswer?form.onlineMonitorQuestionTwoAnswer.some(o => o === '废气'):false" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'onlineMonitorQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'onlineMonitorQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'onlineMonitorQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'onlineMonitorQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.onlineMonitorQuestionFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>在线监测是否联网、备案、验收：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('onlineMonitorQuestionFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('onlineMonitorQuestionFiveAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'onlineMonitorQuestionFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'onlineMonitorQuestionFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'onlineMonitorQuestionFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'onlineMonitorQuestionFiveAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.onlineMonitorQuestionSixAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>在线监测设施运行是否正常：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('onlineMonitorQuestionSixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('onlineMonitorQuestionSixAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'onlineMonitorQuestionSixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'onlineMonitorQuestionSixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'onlineMonitorQuestionSixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'onlineMonitorQuestionSixAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='suddenEnvIncidents'">
          <van-collapse v-model="suddenEnvIncidentsActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>突发环境事件管理</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.suddenEnvQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.suddenEnvQuestionOneAnswer==='涉及'" name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>应急预案</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.SUDDEN_ENV_INCIDENTS_CHECK_REQUIRE_ONE)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.suddenEnvQuestionTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.EMERGENCY_RISK_LEVEL" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>应急预案风险等级：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('suddenEnvQuestionTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('suddenEnvQuestionTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'suddenEnvQuestionTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'suddenEnvQuestionTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionTwoAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.suddenEnvQuestionTwoAnswer && form.suddenEnvQuestionTwoAnswer !== '未备案'" v-model="form.suddenEnvQuestionThreeAnswer" :disabled="isCacheWork==='1'"
                         input-align="left" readonly @click="HandleSelectDateTime" placeholder="请选择应急预案备案日期" class="custom-field" label-width="100%">
                <template #right-icon>
                  <van-icon name="arrow"/>
                </template>
                <template #label>
                  <div class="custom-label2" style="margin-bottom: 5px">
                    <span>应急预案备案日期：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click.stop="addRemarks('suddenEnvQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('suddenEnvQuestionThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'suddenEnvQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'suddenEnvQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.suddenEnvQuestionTwoAnswer && form.suddenEnvQuestionTwoAnswer !== '未备案'" v-model="form.suddenEnvQuestionSevenAnswer" :disabled="isCacheWork==='1'" @blur="handleAutoDateTime"
                         type="digit" input-align="left" placeholder="请输入有效期年限-示例： 3" class="custom-field" label-width="100%">
                <template #label>
                  <div class="custom-label2" style="margin-bottom: 5px">
                    <span>应急预案有效期：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('suddenEnvQuestionSevenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('suddenEnvQuestionSevenAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionSevenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'suddenEnvQuestionSevenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'suddenEnvQuestionSevenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionSevenAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.suddenEnvQuestionTwoAnswer && form.suddenEnvQuestionTwoAnswer !== '未备案'" v-model="form.suddenEnvQuestionEightAnswer" readonly :disabled="isCacheWork==='1'" type="input" input-align="left" placeholder="自动生成应急预案到期日期" class="custom-field" label-width="100%">
                <template #label>
                  <div class="custom-label2" style="margin-bottom: 5px">
                    <span>应急预案到期日期：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('suddenEnvQuestionEightAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('suddenEnvQuestionEightAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionEightAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'suddenEnvQuestionEightAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'suddenEnvQuestionEightAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionEightAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.suddenEnvQuestionFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否安装雨水截止阀：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('suddenEnvQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('suddenEnvQuestionFourAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'suddenEnvQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'suddenEnvQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.suddenEnvQuestionFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否按风险评估报告整改计划落实整改措施：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('suddenEnvQuestionFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('suddenEnvQuestionFiveAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'suddenEnvQuestionFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'suddenEnvQuestionFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionFiveAnswer')].remark"/>
                </template>
              </van-field>
              <van-popup v-model="showSelectDateTime" position="bottom" round>
                <van-datetime-picker class="data-picker-color"
                  v-model="selectDateTime" type="date" title="选择应急预案日期" :formatter="formatter"
                  @cancel="showSelectDateTime = false" @confirm="handleConfirmDateTime"/>
              </van-popup>
            </van-collapse-item>
            <van-collapse-item v-if="form.suddenEnvQuestionOneAnswer==='涉及'" name="3" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>应急演练与培训</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.SUDDEN_ENV_INCIDENTS_CHECK_REQUIRE_TWO)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.suddenEnvQuestionSixAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否进行应急预案演练并保留了相关资料：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('suddenEnvQuestionSixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('suddenEnvQuestionSixAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionSixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'suddenEnvQuestionSixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'suddenEnvQuestionSixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'suddenEnvQuestionSixAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='odsModule'">
          <van-collapse v-model="odsModuleActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>企业是否涉及ODS?</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.odsModuleQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <van-field v-if="form.odsModuleQuestionOneAnswer === '涉及'" name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.odsModuleQuestionTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item" shape="square" v-for="(item, index) in PROTOCOL.ODS_MODULE_BUSINESS_TYPE" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>业务类型：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('odsModuleQuestionTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('odsModuleQuestionTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'odsModuleQuestionTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'odsModuleQuestionTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'odsModuleQuestionTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'odsModuleQuestionTwoAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.odsModuleQuestionOneAnswer==='涉及'" name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>ODS经营管理情况</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.ODS_MODULE_CHECK_REQUIRE)" size="20px"/>
                </div>
              </template>
              <van-field name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.odsModuleQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item-other" shape="square" v-for="(item, index) in PROTOCOL.ODS_MODULE_ODS_TYPE" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                    <van-field v-if="!!(form.odsModuleQuestionThreeAnswer && form.odsModuleQuestionThreeAnswer.some(o => o === '其他'))" input-align="center"
                               v-model="form.odsModuleQuestionThreeAnswerOther" :disabled="isCacheWork==='1'" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 70px" placeholder="填写"/>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>企业涉及ODS类型：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('odsModuleQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('odsModuleQuestionThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'odsModuleQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'odsModuleQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'odsModuleQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'odsModuleQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.odsModuleQuestionFourAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.ODS_MODULE_YNH" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>企业是否已完成备案：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('odsModuleQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('odsModuleQuestionFourAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'odsModuleQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'odsModuleQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'odsModuleQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'odsModuleQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.odsModuleQuestionFiveAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>企业经营活动原始资料保存是否完整：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('odsModuleQuestionFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('odsModuleQuestionFiveAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'odsModuleQuestionFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'odsModuleQuestionFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'odsModuleQuestionFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'odsModuleQuestionFiveAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.odsModuleQuestionSixAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.ODS_MODULE_YNH" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>企业是否完成系统数据报送：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('odsModuleQuestionSixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('odsModuleQuestionSixAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'odsModuleQuestionSixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'odsModuleQuestionSixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'odsModuleQuestionSixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'odsModuleQuestionSixAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='boilerKilnFeiSaid'">
          <van-collapse v-model="boilerKilnFeiSaidActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>锅炉与炉窑</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.boilerSaidQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>非道路移动机械</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.boilerSaidQuestionTwoAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.boilerSaidQuestionOneAnswer==='涉及'" name="3" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>锅炉与炉窑</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.BOILER_KILN_FEI_SAID_CHECK_REQUIRE_ONE)" size="20px"/>
                </div>
              </template>
              <van-field name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.boilerSaidQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item" shape="square" v-for="(item, index) in PROTOCOL.BOILER_KILN_TYPE" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>锅炉及炉窑类别：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('boilerSaidQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('boilerSaidQuestionThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'boilerSaidQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'boilerSaidQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.boilerSaidQuestionThreeAnswer?form.boilerSaidQuestionThreeAnswer.some(o => o === '锅炉'):false" name="checkbox"
                         v-model="form.boilerSaidQuestionFourAnswer" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="boilerOrSaid.boilerInfo.fuelType" :disabled="isCacheWork==='1'" direction="horizontal" @change="handleBoilerSaidCheckboxChange(1)">
                    <van-checkbox class="checkbox-item" shape="square" name="燃油">燃油</van-checkbox>
                    <div v-if="isCheckBox(1,'燃油')" style="display: flex; align-items: center; gap: 8px; margin-right: 20px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.boilerInfo.fuelNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(1)" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                    <van-checkbox class="checkbox-item" shape="square" name="燃气">燃气</van-checkbox>
                    <div v-if="isCheckBox(1,'燃气')" style="display: flex; align-items: center; gap: 8px; margin-right: 20px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.boilerInfo.gasNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(1)" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                    <van-checkbox class="checkbox-item" shape="square" name="燃生物质">燃生物质</van-checkbox>
                    <div v-if="isCheckBox(1,'燃生物质')" style="display: flex; align-items: center;margin-right: 20px; gap: 8px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.boilerInfo.burningBiomassNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(1)" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                    <van-checkbox class="checkbox-item" shape="square" name="电">电</van-checkbox>
                    <div v-if="isCheckBox(1,'电')" style="display: flex; align-items: center; margin-right: 20px; gap: 8px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.boilerInfo.electricalNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(1)" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                    <van-checkbox class="checkbox-item" shape="square" name="其他">其他</van-checkbox>
                    <van-field v-if="isCheckBox(1,'其他')" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 70px" v-model="form.boilerSaidQuestionFourAnswerOther" :disabled="isCacheWork==='1'" input-align="center" placeholder="填写"/>
                    <div v-if="isCheckBox(1,'其他')" style="display: flex; align-items: center; margin-right: 20px; gap: 8px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.boilerInfo.otherNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(1)"
                                 style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>燃料类型及数量（锅炉）：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('boilerSaidQuestionFourAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('boilerSaidQuestionFourAnswer') && form.boilerSaidQuestionThreeAnswer?form.boilerSaidQuestionThreeAnswer.some(o => o === '锅炉'):false" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionFourAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'boilerSaidQuestionFourAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'boilerSaidQuestionFourAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionFourAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.boilerSaidQuestionThreeAnswer?form.boilerSaidQuestionThreeAnswer.some(o => o === '锅炉'):false" name="textarea" class="custom-field" label-width="100%">
                <template #input>
                  <textarea class="radio-item" v-model="form.boilerSaidQuestionFiveAnswer" :disabled="isCacheWork==='1'" placeholder="请输入用途" style="width: 99%;
                  border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30"/>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>用途（锅炉）：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('boilerSaidQuestionFiveAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('boilerSaidQuestionFiveAnswer') && form.boilerSaidQuestionThreeAnswer?form.boilerSaidQuestionThreeAnswer.some(o => o === '锅炉'):false" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionFiveAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'boilerSaidQuestionFiveAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'boilerSaidQuestionFiveAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionFiveAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.boilerSaidQuestionThreeAnswer?form.boilerSaidQuestionThreeAnswer.some(o => o === '炉窑'):false" name="checkbox" v-model="form.boilerSaidQuestionSixAnswer" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="boilerOrSaid.furnaceInfo.fuelType" :disabled="isCacheWork==='1'" direction="horizontal" @change="handleBoilerSaidCheckboxChange(2)">
                    <van-checkbox class="checkbox-item" shape="square" name="加热炉">加热炉</van-checkbox>
                    <div v-if="isCheckBox(2,'加热炉')" style="display: flex; align-items: center; gap: 8px; margin-right: 10px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.furnaceInfo.heatingFurnaceNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(2)" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                    <van-checkbox class="checkbox-item" shape="square" name="热处理炉">热处理炉</van-checkbox>
                    <div v-if="isCheckBox(2,'热处理炉')" style="display: flex; align-items: center; gap: 8px; margin-right: 10px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.furnaceInfo.heatTreatmentFurnaceNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(2)" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                    <van-checkbox class="checkbox-item" shape="square" name="熔化炉">熔化炉</van-checkbox>
                    <div v-if="isCheckBox(2,'熔化炉')" style="display: flex; align-items: center;margin-right: 10px; gap: 8px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.furnaceInfo.meltingFurnaceNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(2)" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                    <van-checkbox class="checkbox-item" shape="square" name="干燥炉">干燥炉</van-checkbox>
                    <div v-if="isCheckBox(2,'干燥炉')" style="display: flex; align-items: center; margin-right: 10px; gap: 8px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.furnaceInfo.dryingFurnaceNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(2)"
                                 style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                    <van-checkbox class="checkbox-item" shape="square" name="其他">其他</van-checkbox>
                    <van-field v-if="isCheckBox(2,'其他')" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 70px" v-model="form.boilerSaidQuestionSixAnswerOther" :disabled="isCacheWork==='1'" input-align="center" placeholder="填写"/>
                    <div v-if="isCheckBox(2,'其他')" style="display: flex; align-items: center; margin-right: 10px; gap: 8px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.furnaceInfo.otherNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(2)" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>炉窑类型及数量（炉窑）：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('boilerSaidQuestionSixAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('boilerSaidQuestionSixAnswer') && form.boilerSaidQuestionThreeAnswer?form.boilerSaidQuestionThreeAnswer.some(o => o === '炉窑'):false" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionSixAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'boilerSaidQuestionSixAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'boilerSaidQuestionSixAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionSixAnswer')].remark"/>
                </template>
              </van-field>
              <van-field v-if="form.boilerSaidQuestionThreeAnswer?form.boilerSaidQuestionThreeAnswer.some(o => o === '炉窑'):false" name="checkbox" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="form.boilerSaidQuestionSevenAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-checkbox class="radio-item" shape="square" v-for="(item, index) in PROTOCOL.FUEL_TYPE" :key="index" :name="item.name">{{item.value}}</van-checkbox>
                    <van-field v-if="!!(form.boilerSaidQuestionSevenAnswer && form.boilerSaidQuestionSevenAnswer.some(o => o === '其他'))"  input-align="center"
                               v-model="form.boilerSaidQuestionSevenAnswerOther" :disabled="isCacheWork==='1'" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 70px" placeholder="填写"/>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>燃料类型（炉窑）：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('boilerSaidQuestionSevenAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('boilerSaidQuestionSevenAnswer') && form.boilerSaidQuestionThreeAnswer?form.boilerSaidQuestionThreeAnswer.some(o => o === '炉窑'):false" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionSevenAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'boilerSaidQuestionSevenAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'boilerSaidQuestionSevenAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionSevenAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.boilerSaidQuestionTwoAnswer==='涉及'" name="4" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>非道路移动机械</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.BOILER_KILN_FEI_SAID_CHECK_REQUIRE_TWO)" size="20px"/>
                </div>
              </template>
              <van-field name="checkbox" v-model="form.boilerSaidQuestionEightAnswer" class="custom-field" label-width="100%">
                <template #input>
                  <van-checkbox-group v-model="boilerOrSaid.saidInfo.deviceType" :disabled="isCacheWork==='1'" direction="horizontal" @change="handleBoilerSaidCheckboxChange(3)">
                    <van-checkbox class="checkbox-item" shape="square" name="柴油">柴油</van-checkbox>
                    <div v-if="isCheckBox(3,'柴油')" style="display: flex; align-items: center; gap: 8px; margin-right: 10px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.saidInfo.dieselNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(3)" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                    <van-checkbox class="checkbox-item" shape="square" name="纯电">纯电</van-checkbox>
                    <div v-if="isCheckBox(3,'纯电')" style="display: flex; align-items: center; gap: 8px; margin-right: 10px">
                      <span>(</span>
                      <van-field v-model="boilerOrSaid.saidInfo.pureElectricNum" :disabled="isCacheWork==='1'" input-align="center" inputmode="numeric" @input="handleBoilerSaidCheckboxChangeNum(3)" style="padding: 0; border-bottom: #0C0C0C 1px solid;width: 40px" :formatter="value => Math.max(0, value.replace(/[^\d]/g, ''))" placeholder="填写"/>
                      <span class="checkbox-item-span">)</span>
                    </div>
                  </van-checkbox-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>设备类型及数量：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('boilerSaidQuestionEightAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('boilerSaidQuestionEightAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionEightAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'boilerSaidQuestionEightAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'boilerSaidQuestionEightAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionEightAnswer')].remark"/>
                </template>
              </van-field>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.boilerSaidQuestionNineAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否全部申报（环保蓝牌)：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('boilerSaidQuestionNineAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('boilerSaidQuestionNineAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionNineAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'boilerSaidQuestionNineAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'boilerSaidQuestionNineAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'boilerSaidQuestionNineAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='administrativePenalty'">
          <van-collapse v-model="administrativePenaltyActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>行政处罚及信用修复情况</span>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.penaltyQuestionOneAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.CHECK_ITEM_STATE" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.penaltyQuestionOneAnswer==='涉及'" name="2" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>行政处罚情况</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.ADMINISTRATIVE_PENALTY_CHECK_REQUIRE_ONE)" size="20px"/>
                </div>
              </template>
              <van-field v-model="form.penaltyQuestionTwoAnswer" :disabled="isCacheWork==='1'" type="input" input-align="left" placeholder="请输入行政处罚文号" class="custom-field" label-width="100%">
                <template #label>
                  <div class="custom-label2" style="margin-bottom: 5px">
                    <span>行政处罚文号：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('penaltyQuestionTwoAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('penaltyQuestionTwoAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'penaltyQuestionTwoAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'penaltyQuestionTwoAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'penaltyQuestionTwoAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'penaltyQuestionTwoAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item v-if="form.penaltyQuestionOneAnswer==='涉及'" name="3" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title">
                  <span>信用修复</span>
                  <van-icon class="title-icon" name="info-o" @click.stop="handleCheckTips(CHECK_REQUIRE.ADMINISTRATIVE_PENALTY_CHECK_REQUIRE_TWO)" size="20px"/>
                </div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.penaltyQuestionThreeAnswer" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio class="radio-item" v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否完成信用修复：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('penaltyQuestionThreeAnswer')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('penaltyQuestionThreeAnswer')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'penaltyQuestionThreeAnswer')].remarkPhotos" multiple
                                :before-read="beforeRead" :max-count="2" :after-read="(file) => afterRead3(file, 'penaltyQuestionThreeAnswer')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'penaltyQuestionThreeAnswer')"/>
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'penaltyQuestionThreeAnswer')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="tabVale==='onSiteSituation'">
          <van-collapse v-model="onSiteSituationActiveNames">
            <van-collapse-item name="1" class="collapse-item-content">
              <template #title>
                <div class="collapse-item-title"><span>摸排情况（或特殊情况说明）</span></div>
              </template>
              <van-field name="radio" class="custom-field" label-width="100%">
                <template #input>
                  <van-radio-group v-model="form.isProblem" :disabled="isCacheWork==='1'" direction="horizontal">
                    <van-radio v-for="(item, index) in PROTOCOL.YES_OR_NO" :key="index" :name="item.name">{{item.value}}</van-radio>
                  </van-radio-group>
                </template>
                <template #label>
                  <div class="custom-label2">
                    <span>是否有异常问题：</span>
                    <van-icon name="label-o" class="title-icon" color="#1C75F6" size="20px" @click="addRemarks('isProblem')"/>
                  </div>
                </template>
              </van-field>
              <van-field v-if="isRemarks('isProblem')" name="remarks" class="custom-field-remarks">
                <template #input>
                  <van-uploader v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'isProblem')].remarkPhotos" multiple
                                :before-read="beforeRead" :after-read="(file) => afterRead3(file, 'isProblem')" :disabled="isCacheWork==='1'"
                                :before-delete="(file, d) => beforeDelRemarkPhotos(file, d,'isProblem')" />
                  <textarea  placeholder="请输入说明" style="width: 99%; border-radius: 5px; border: 1px solid #e3e3e3" rows="3" cols="30" :disabled="isCacheWork==='1'"
                             v-model="workRecordCheckItemRemarks[workRecordCheckItemRemarks.findIndex(item => item.itemName === 'isProblem')].remark"/>
                </template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-form>
      <van-action-sheet v-model="sheet.showActionSheet" title="要求" cancel-text="我知道了" close-on-popstate :description="sheet.description"/>
      <van-popup v-model="popup.show" round position="bottom" :style="{ height: '50%' }" >
        <div style="height: 10%;display: flex;align-items: center;justify-content: center;font-size: 18px;color:#333333">完成情况</div>
        <div style="height: 77%">
          <van-grid :column-num="4" style="height: 100%;overflow-y: auto">
            <van-grid-item v-for="(item, index) in PRODUCTION_NORMAL?completionList:completionList2" :key="index" class="grid-item-popup" @click="handleUncompletedInspections(item.value)">
              <div class="grid-item-icon" :style="item.option?'background-color: #1C75F6;color: #FFFFFF; font-size: 18px; width: 50px; height: 50px;':'background-color: #E9E9E9;color: #333333; font-size: 18px; width: 50px; height: 50px;'">
                {{item.index}}
              </div>
              <div>{{item.title}}</div>
            </van-grid-item>
          </van-grid>
        </div>
        <div style="height: 13%;border-top: #f1f0f0 2px solid;display: flex;align-items: center;justify-content: center;font-size: 16px;color: #1B75F6" @click="popup.show = false">我知道了</div>
      </van-popup>
    </div>
    <div style="position: fixed;bottom: 0;width: 100%;text-align: center">
      <van-button v-if="tabVale!=='onSiteSituation'" color="#1B75F6" native-type="button" @click="handleNextCheckItem">下一步</van-button>
      <van-button v-if="isCacheWork!=='4' && tabVale==='onSiteSituation'" color="#1B75F6"  native-type="button" @click="sub1" :disabled="isCacheWork==='1'" :loading="subButtonLoading">完成提交</van-button>
      <van-button v-if="isCacheWork==='4'" color="#1B75F6" native-type="button" @click="sub1" style="margin: 0 30px" :disabled="isCacheWork==='1'" :loading="subButtonLoading">重新提交</van-button>
      <van-button v-else type="warning" native-type="button" @click="saveCache" :disabled="isCacheWork==='1'"   style="margin-left: 30px;width: 90px">暂存</van-button>
    </div>
    <van-popup v-model="signModal" position="bottom" :style="{ height: '100%' }" style="z-index: 99999">
      <van-nav-bar left-text="返回" left-arrow @click-left="signBack" id="topbar"/>
      <div class="esigns" ref="signDivRef">
        <sign-canvas class="sign-canvas" ref="signCanvasRef" :options="options" v-model="signCanvasVal"/>
        <div class="sign-text2">本次摸排对接人签字</div>
        <div class="sign-text1" @click="handleClear">清空</div>
        <div class="sign-text" @click="handleConfirm">提交</div>
      </div>
      <div v-show="subLoading" style="background-color: rgba(0, 0, 0, 0.5);position: absolute;z-index: 999;height: 120%;width: 100%;top: -20%">
        <van-loading  type="spinner" style="position: absolute;top: 55%;left: 50%;z-index: 999" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue';
import uploadfilecommon from '@/libs/uploadfilecommon';
import {Toast, Dialog} from 'vant';
import $ from '@/fly'
import SignCanvas from "sign-canvas";   //局部注册
import Setting from '@/setting';
import {WorkRecordCheckItemRemarksStore, WorkRecordsStore} from '@/libs/indexedDB'
import vueEsign from 'vue-esign'
import {CHECK_REQUIRE, NO_CHECK_QUESTION, PROTOCOL, TABS_LIST} from "@/libs/constants";
import _ from "lodash";
Vue.use(vueEsign)
Vue.use(Toast);

//移除数组中对象得属性
const removePropInPlace = (arr, prop) => {
  return arr.map(obj => {
    const newObj = {...obj}; // 避免修改原对象
    delete newObj[prop];
    return newObj;
  });
};

//将对象数组中的指定数组属性转换为逗号分隔字符串
const convertArrayPropToString = (arr, prop) => {
  return arr.map(obj => ({
    ...obj,                // 保留其他属性
    [prop]: obj[prop].join() // 将目标数组转为字符串
  }));
}

export default {
  name: 'project-companyVerification',
  components:{
    SignCanvas
  },
  data() {
    return {
      rotatedImageDataUrl: '',
      isCacheWork: '',
      signCanvasVal: null,
      options: {
        isDpr: true, //是否使用dpr兼容高倍屏 [Boolean] 可选
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 2, //下笔的宽度 [Number] 可选
        lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]    正方形线帽
        lineJoin: "bevel", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: 350, //canvas宽高 [Number] 可选
        canvasHeight: 370, //高度  [Number] 可选
        isShowBorder: false, //是否显示边框 [可选]
        bgColor: "#ffffff", //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: "#808080", //网格颜色  [String] 可选
        writeWidth: 5, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: "#101010", // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      },  //签字配置
      maskShow:false,
      clientHeight: window.screen.height,
      apiBaseURL: Setting.apiBaseURL,
      companyId: '',
      companyName: '',
      signInShow: false,
      projectId: '',
      signAddress: '',
      lng: 0,
      lat: 0,
      loaded: false,
      fileds: false,
      map: '',
      workIsNull: false, //false 只读
      attIds: [],
      cacheWork: {},
      isCache:false,
      workId:0,
      isWorkId:true,
      isWork:true,
      signModal: false,
      isCrop: false,
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      subLoading: false,
      subButtonLoading: false,   //是否开启签字加载
      form:{},
      workRecordCheckItemRemarks:[],
      tabVale:null,
      showSelectIndustry: false,
      industryName:'', //搜索框参数
      industryList:[],
      selectIndustryList:[],
      selectIndustry:{
        selectedCode: '', // 存储选中项的code
        selectedName: ''
      },
      envPermitActiveNames: ['1','2','3','4','5','6','7','8','9','10','11'],
      potentialRisksActiveNames: ['1','2','3','4','5','6'],
      proWasteGasActiveNames: ['1','2'],
      proWasteWaterActiveNames: ['1','2'],
      chemSolidWasteActiveNames:['1','2','3','4','5','6'],
      soilGroundwaterActiveNames: ['1','2'],
      selfMonitorActiveNames: ['1','2'],
      onlineMonitorActiveNames: ['1','2'],
      odsModuleActiveNames: ['1','2'],
      suddenEnvIncidentsActiveNames: ['1','2','3'],
      boilerKilnFeiSaidActiveNames: ['1','2','3','4'],
      administrativePenaltyActiveNames:['1','2','3'],
      onSiteSituationActiveNames:['1'],
      sheet:{
        showActionSheet:false,
        description:''
      },
      popup:{
        show:false
      },
      baseInfo:{
        showMoveOut:false,   //是否选择搬迁
        moveOutName:''       //搬迁写入的名称
      },
      boilerOrSaid:{
        boilerInfo:{
          fuelType:[],
          fuelNum:0,
          gasNum:0,
          burningBiomassNum:0,
          electricalNum:0,
          otherNum:0
        },
        furnaceInfo:{
          fuelType:[],
          heatingFurnaceNum:0,
          heatTreatmentFurnaceNum:0,
          meltingFurnaceNum:0,
          dryingFurnaceNum:0,
          otherNum:0
        },
        saidInfo:{
          deviceType:[],
          dieselNum:0,
          pureElectricNum:0
        }
      },
      remarkPhotos: [],
      remarkPhotoIds: [],
      completionList: [ //答题完成情况
        {index:1, title:'基本信息', value: 'basicInfo', option:false},
        {index:2, title:'环保许可', value: 'envPermit', option:false},
        {index:3, title:'风险隐患', value: 'potentialRisks', option:false},
        {index:4, title:'生产废气', value: 'proWasteGas', option:false},
        {index:5, title:'生产废水', value: 'proWasteWater', option:false},
        {index:6, title:'化学品|固废', value: 'chemSolidWaste', option:false},
        {index:7, title:'土壤|地下水', value: 'soilGroundwater', option:false},
        {index:8, title:'自行监测', value: 'selfMonitor', option:false},
        {index:9, title:'在线监控', value: 'onlineMonitor', option:false},
        {index:10, title:'突发环境事件', value: 'suddenEnvIncidents', option:false},
        {index:11, title:'ODS模块', value: 'odsModule', option:false},
        {index:12, title:'锅炉炉窑|非道', value: 'boilerKilnFeiSaid', option:false},
        {index:13, title:'行政处罚', value: 'administrativePenalty', option:false},
        {index:14, title:'摸排情况', value: 'onSiteSituation', option:true}
      ],
      completionList2: [
        {index:1, title:'基本信息', value: 'basicInfo', option:false},
        {index:2, title:'摸排情况', value: 'onSiteSituation', option:true}
      ],
      delCache: true,
      showSelectDateTime:false,  //开启日期选择
      selectDateTime:new Date()
    }
  },
  computed: {
    TABS_LIST() {
      return this.PRODUCTION_NORMAL?TABS_LIST.CHECK_ITEM_TABS_LIST:TABS_LIST.CHECK_ITEM_TABS_LIST2
    },
    PROTOCOL() {
      return PROTOCOL
    },
    CHECK_REQUIRE() {
      return CHECK_REQUIRE
    },
    PRODUCTION_NORMAL() {
      const res = !!(this.form.productionStatus && (this.form.productionStatus === '正常生产' || this.form.productionStatus === '其他'))
      if (res) {
        if (!this.form.isNightProduction) this.$set(this.form,'isNightProduction','否');
      } else {
        this.$delete(this.form,'isNightProduction')
      }
      return res;
    }
  },
  methods: {
    //清空签名
    handleClear() {
      this.$refs.signCanvasRef.canvasClear();
    },
    //无问题提交
    async handleConfirm() {
      this.subLoading = true
      this.cacheLocal()
      this.delCache = false
      const _this = this;
      let res1 = this.$refs.signCanvasRef.saveAsImg();
      const img = new Image();
      img.src = res1;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        // 设置canvas大小与图片相同 计算旋转后的宽高
        const rotatedWidth = img.height;
        const rotatedHeight = img.width;
        // 设置canvas宽高为旋转后的宽高
        canvas.width = rotatedWidth;
        canvas.height = rotatedHeight;
        // 旋转图片
        ctx.translate(rotatedWidth / 2, rotatedHeight / 2);
        ctx.rotate((-90 * Math.PI) / 180); // 旋转指定角度
        ctx.drawImage(img, -img.width / 2, -img.height / 2, img.width, img.height);
        // 获取旋转后的图片数据
        this.rotatedImageDataUrl = canvas.toDataURL('image/png');
        this.maskShow = true
        const file = _this.dataURLtoFile(this.rotatedImageDataUrl);  // 转成文件
        //调用接口 上传文件
        $.uploadSignFile(file, {businessModule: 'OIL_WASTE_WATER_DOSING_SIGN'}).then(res => {
          if (res != null && res !== '') {
            const projectId = localStorage.getItem('projectId')
            const user = JSON.parse(localStorage.getItem('USER'))
            //添加空的问题任务表
            if (this.isCacheWork === '4') {
              localStorage.setItem('workId',null)
              this.$set(this.form,'signPhotosId',res)
              const workRecordCheckItemRemarks = convertArrayPropToString(removePropInPlace(this.workRecordCheckItemRemarks,'remarkPhotos'),'attachmentId')
              const workRecords = {
                ...this.form,
                proWasteWaterQuestionSeventeenthAnswer:this.form.proWasteWaterQuestionSeventeenthAnswer?.join(),
                proWasteGasQuestionThreeAnswer:this.form.proWasteGasQuestionThreeAnswer?.join(),
                proWasteGasQuestionSixAnswer:this.form.proWasteGasQuestionSixAnswer?.join(),
                proWasteWaterQuestionSevenAnswer:this.form.proWasteWaterQuestionSevenAnswer?.join(),
                onlineMonitorQuestionTwoAnswer:this.form.onlineMonitorQuestionTwoAnswer?.join(),
                onlineMonitorQuestionThreeAnswer:this.form.onlineMonitorQuestionThreeAnswer?.join(),
                onlineMonitorQuestionFourAnswer:this.form.onlineMonitorQuestionFourAnswer?.join(),
                boilerSaidQuestionThreeAnswer:this.form.boilerSaidQuestionThreeAnswer?.join(),
                boilerSaidQuestionSevenAnswer:this.form.boilerSaidQuestionSevenAnswer?.join(),
                odsModuleQuestionTwoAnswer:this.form.odsModuleQuestionTwoAnswer?.join(),
                odsModuleQuestionThreeAnswer:this.form.odsModuleQuestionThreeAnswer?.join(),
              }
              //编辑检查记录
              $.put('workRecords/workSubmit', {
                workRecords: JSON.stringify(workRecords),
                remarksList: JSON.stringify(workRecordCheckItemRemarks),
              },{contentType: 'application/json'}).then(() => {
                this.workIsNull = true
                Toast.success('修改成功！');
                if(this.workId>0){
                  WorkRecordsStore.delete(this.workId)
                  WorkRecordCheckItemRemarksStore.delete(this.workId)
                }
                this.signModal = false
                this.subLoading = false
                localStorage.removeItem('workRecordItem')
                this.$router.back()
              }).catch(err => {
                this.signModal = false
                this.subLoading = false;
                Toast.fail({
                  message: `${err?.message || '操作失败，请重试'}`,
                  duration: 5000
                });
                console.error('提交异常详情：', err);
              })
            } else {
              $.put('problemCheckTask', {
                'checkUserId': user.userId,
                'companyId': this.form.companyId,
                'projectId': projectId,
                'submitDate': new Date(),
                'submitStatus': '1',
                'signFileId': res,
                'createDate': new Date(),
                'isNull': '0'
              }).then(()=>{
                localStorage.setItem('workId',null)
                this.$set(this.form,'signPhotosId',res)
                const workRecordCheckItemRemarks = convertArrayPropToString(removePropInPlace(this.workRecordCheckItemRemarks,'remarkPhotos'),'attachmentId')
                const workRecords = {
                  ...this.form,
                  proWasteWaterQuestionSeventeenthAnswer:this.form.proWasteWaterQuestionSeventeenthAnswer?.join(),
                  proWasteGasQuestionThreeAnswer:this.form.proWasteGasQuestionThreeAnswer?.join(),
                  proWasteGasQuestionSixAnswer:this.form.proWasteGasQuestionSixAnswer?.join(),
                  proWasteWaterQuestionSevenAnswer:this.form.proWasteWaterQuestionSevenAnswer?.join(),
                  onlineMonitorQuestionTwoAnswer:this.form.onlineMonitorQuestionTwoAnswer?.join(),
                  onlineMonitorQuestionThreeAnswer:this.form.onlineMonitorQuestionThreeAnswer?.join(),
                  onlineMonitorQuestionFourAnswer:this.form.onlineMonitorQuestionFourAnswer?.join(),
                  boilerSaidQuestionThreeAnswer:this.form.boilerSaidQuestionThreeAnswer?.join(),
                  boilerSaidQuestionSevenAnswer:this.form.boilerSaidQuestionSevenAnswer?.join(),
                  odsModuleQuestionTwoAnswer:this.form.odsModuleQuestionTwoAnswer?.join(),
                  odsModuleQuestionThreeAnswer:this.form.odsModuleQuestionThreeAnswer?.join(),
                }
                //添加检查记录
                workRecords.id = null
                $.put('workRecords/workSubmit', {
                  workRecords: JSON.stringify(workRecords),
                  remarksList: JSON.stringify(workRecordCheckItemRemarks),
                },{contentType: 'application/json'}).then(res => {
                  this.form.id = res   //返回id
                  this.workIsNull = true
                  Toast.success('提交成功！');
                  if (this.isCacheWork==='2') {
                    $.delete('/workRecords/delCloudCacheByCode',{
                      projectId: localStorage.getItem('projectId'),
                      companyId: this.companyId,
                      cacheCode: workRecords.cacheCode
                    }).catch(error => {
                      console.log('云端待提交记录提交后删除失败，原因为：',error)
                    })
                  }
                  if(this.workId>0){
                    WorkRecordsStore.delete(this.workId)
                    WorkRecordCheckItemRemarksStore.delete(this.workId)
                  }
                  this.signModal = false
                  this.subLoading = false
                  this.$router.back()
                }).catch(err => {
                  this.signModal = false
                  this.subLoading = false;
                  Toast.fail({
                    message: `${err?.message || '操作失败，请重试'}`,
                    duration: 5000
                  });
                  console.error('提交异常详情：', err);
                })
              }).catch(err => {
                this.signModal = false
                this.subLoading = false;
                Toast.fail({
                  message: `${err?.message || '操作失败，请重试'}`,
                  duration: 5000
                });
                console.error('提交异常详情：', err);
              })
            }
          }
        }).catch(err => {
          this.signModal = false
          this.subLoading = false;
          Toast.fail({
            message: `${err?.message || '操作失败，请重试'}`,
            duration: 5000
          });
          console.error('提交异常详情：', err);
        })
      };
    },
    handleConfirm1() {
      this.cacheLocal()
      this.delCache = false
      localStorage.setItem('workId',null)
      const workRecordCheckItemRemarks = convertArrayPropToString(removePropInPlace(this.workRecordCheckItemRemarks,'remarkPhotos'),'attachmentId')
      const workRecords = {
        ...this.form,
        proWasteWaterQuestionSeventeenthAnswer:this.form.proWasteWaterQuestionSeventeenthAnswer?.join(),
        proWasteGasQuestionThreeAnswer:this.form.proWasteGasQuestionThreeAnswer?.join(),
        proWasteGasQuestionSixAnswer:this.form.proWasteGasQuestionSixAnswer?.join(),
        proWasteWaterQuestionSevenAnswer:this.form.proWasteWaterQuestionSevenAnswer?.join(),
        onlineMonitorQuestionTwoAnswer:this.form.onlineMonitorQuestionTwoAnswer?.join(),
        onlineMonitorQuestionThreeAnswer:this.form.onlineMonitorQuestionThreeAnswer?.join(),
        onlineMonitorQuestionFourAnswer:this.form.onlineMonitorQuestionFourAnswer?.join(),
        boilerSaidQuestionThreeAnswer:this.form.boilerSaidQuestionThreeAnswer?.join(),
        boilerSaidQuestionSevenAnswer:this.form.boilerSaidQuestionSevenAnswer?.join(),
        odsModuleQuestionTwoAnswer:this.form.odsModuleQuestionTwoAnswer?.join(),
        odsModuleQuestionThreeAnswer:this.form.odsModuleQuestionThreeAnswer?.join(),
      }
      //编辑检查记录
      $.put('workRecords/workSubmit', {
        workRecords: JSON.stringify(workRecords),
        remarksList: JSON.stringify(workRecordCheckItemRemarks),
      },{contentType: 'application/json'}).then(() => {
        this.workIsNull = true
        Toast.success('修改成功！');
        if(this.workId>0){
          WorkRecordsStore.delete(this.workId)
          WorkRecordCheckItemRemarksStore.delete(this.workId)
        }
        localStorage.removeItem('workRecordItem')
        this.$router.back()
      }).catch(err => {
        Toast.fail({
          message: `${err?.message || '操作失败，请重试'}`,
          duration: 5000
        });
        console.error('提交异常详情：', err);
      })
    },
    //签字返回
    signBack(){
      if(!this.maskShow){
        this.signModal=false
      }
    },
    //退出核查
    checkPageBack(){
      if (this.delCache && this.workId>0) {
        WorkRecordsStore.delete(this.workId)
        WorkRecordCheckItemRemarksStore.delete(this.workId);
      }
      this.$router.back()
    },
    //删除文件（上一个版本）
    // removeAttId(attId){
    //   console.log(attId)
    //   this.attIds = this.attIds.filter(att=> att!=attId)
    //   $.delete('deleteFile/' + attId).then(res => {
    //     Toast.success('删除成功！');
    //     return true;
    //   }).catch(err => {
    //     Toast.fail(err.message);
    //     return false;
    //   })
    // },
    getCurrentTime() {
      //获取当前时间并打印
      const _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
      _this.gettime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
      return _this.gettime
    },
    //暂存 （有网缓存云端/无网缓存本地）
    async saveCache() {
      try {
        if (navigator.onLine) {
          await this.cacheCloud();
        } else {
          await Dialog.confirm({
            title: '确认提示',
            message: '当前暂无网络，是否暂存本地<br><span style="color:#da0505;">如暂存本地，所有图片不支持暂存</span>',
            dangerouslyUseHTMLString: true
          });
          this.cacheLocal();
        }
        // 暂存完成清除浏览器缓存数据
        Toast.success('暂存成功！');
        localStorage.removeItem('isCacheWork');
        if (this.isCacheWork === '0' || this.isCacheWork === '3') {
          localStorage.removeItem('indexdbCacheId');
        } else if (this.isCacheWork === '2') {
          localStorage.removeItem('cloudCacheCode');
        }
        this.$router.back();
      } catch (error) {
        // 捕获用户取消操作（取消本地保存），不执行任何操作，终止流程
        console.log('用户取消保存', error);
      }
    },
    //缓存云端（返回Promise，便于上层await控制流程）
    cacheCloud() {
      return new Promise((resolve, reject) => {
        const work = {
          ...this.form,
          signTime: this.getCurrentTime()
        };
        const workRemarks = {
          id: this.form.id,
          remarks: convertArrayPropToString(removePropInPlace(this.workRecordCheckItemRemarks,'remarkPhotos'),'attachmentId')
        };

        $.put('workRecords/cacheCloud', {
          workRecords: JSON.stringify(work),
          remarksList: JSON.stringify(workRemarks),
        }, {
          contentType: 'application/json'
        }).then(() => {
          if (this.isCacheWork === '0' || this.isCacheWork === '3') {
            WorkRecordsStore.delete(this.workId);
            WorkRecordCheckItemRemarksStore.delete(this.workId);
          }
          resolve();
        }).catch(async (err) => {
          try {
            // 云端保存失败，询问是否本地保存
            await Dialog.confirm({
              title: '确认提示',
              message: '暂存云端失败，是否暂存本地。失败原因：' + err.message
            });
            // 用户确认，执行本地保存并resolve
            this.cacheLocal();
            resolve();
          } catch (cancelErr) {
            // 用户取消本地保存，reject终止流程
            reject(cancelErr);
          }
        });
      });
    },
    //缓存本地
    cacheLocal(){
      const work = {
        ...this.form,
        signTime: this.getCurrentTime()
      };
      const workRemarks = {
        id:this.form.id,
        remarks:JSON.stringify(convertArrayPropToString(removePropInPlace(this.workRecordCheckItemRemarks,'remarkPhotos'),'attachmentId'))
      }
      this.limitLocalCacheNum(work,workRemarks)
    },
    //限制本地缓存数量
    async limitLocalCacheNum(work,workRemarks) {
      const list = (await WorkRecordsStore.toArray())
        .filter(record => record.projectId == localStorage.getItem('projectId') && record.companyId == this.companyId)
        .sort((f, s) => s.id - f.id) ||[]
      if (list.length>2) {
        if (_.find(list, { id: work.id })) {
          list.slice(2).forEach(item => {
            WorkRecordsStore.delete(item.id);
            WorkRecordCheckItemRemarksStore.delete(item.id);
          });
          // const lastItem = _.last(list);
          // WorkRecordsStore.delete(lastItem.id)
          // WorkRecordCheckItemRemarksStore.delete(lastItem.id)
        }
      }
      WorkRecordsStore.put(work)
      WorkRecordCheckItemRemarksStore.put(workRemarks)
    },
    //提交表单填写
    async sub1() {
      if (this.handleDetectionCheckCompleted()) {
        this.subButtonLoading = true
        if(this.form.isProblem==='是' && this.isCacheWork !== '4'){
          await Dialog.confirm({title: '确认提示', message: '是否跳转至现场问题页面？'})
            .then(() => {
              this.cacheLocal()
              this.delCache = false
              // on confirm  进入问题页面
              let projectId = localStorage.getItem('projectId')
              let userId = JSON.parse(localStorage.getItem('USER')).userId
              // if (this.isCacheWork === '4') {
                // $.get('problemCheckTask',
                //   { checkUserId: this.form.createUser, companyId: this.form.companyId, projectId: projectId, dateTime:this.form.createTime})
                //   .then(res => {
                //     localStorage.setItem('task', JSON.stringify(res))
                //     localStorage.setItem('problemIds', '')
                //     localStorage.setItem('workId',null)
                //     //移除数组中对象得属性
                //     const workRecordCheckItemRemarks = convertArrayPropToString(removePropInPlace(this.workRecordCheckItemRemarks,'remarkPhotos'),'attachmentId')
                //     const workRecords = {
                //       ...this.form,
                //       proWasteWaterQuestionSeventeenthAnswer:this.form.proWasteWaterQuestionSeventeenthAnswer?.join(),
                //       proWasteGasQuestionThreeAnswer:this.form.proWasteGasQuestionThreeAnswer?.join(),
                //       proWasteGasQuestionSixAnswer:this.form.proWasteGasQuestionSixAnswer?.join(),
                //       proWasteWaterQuestionSevenAnswer:this.form.proWasteWaterQuestionSevenAnswer?.join(),
                //       onlineMonitorQuestionTwoAnswer:this.form.onlineMonitorQuestionTwoAnswer?.join(),
                //       onlineMonitorQuestionThreeAnswer:this.form.onlineMonitorQuestionThreeAnswer?.join(),
                //       onlineMonitorQuestionFourAnswer:this.form.onlineMonitorQuestionFourAnswer?.join(),
                //       boilerSaidQuestionThreeAnswer:this.form.boilerSaidQuestionThreeAnswer?.join(),
                //       boilerSaidQuestionSevenAnswer:this.form.boilerSaidQuestionSevenAnswer?.join()
                //     };
                //     let data = {
                //       workRecords: JSON.stringify(workRecords),
                //       remarksList: JSON.stringify(workRecordCheckItemRemarks),
                //       workRecordsId: this.form.id
                //     }
                //     localStorage.setItem('workRecordData',JSON.stringify(data))
                //     this.$router.push({name: 'project-problemCheckTaskIndex'})
                //   })
                //   .catch((err) => {
                //     Toast.fail({
                //       message: `${err?.message || '操作失败，请重试'}`,
                //       duration: 5000
                //     });
                //   })
              // } else {
              $.post('problemCheckTask', {'checkUserId': userId, 'companyId': this.form.companyId, 'projectId': projectId, 'submitStatus': 0})
                .then(res => {
                  localStorage.setItem('task', JSON.stringify(res))  //任务对象
                  localStorage.setItem('problemIds', '')
                  localStorage.setItem('workId',null)
                  //移除数组中对象得属性
                  const workRecordCheckItemRemarks = convertArrayPropToString(removePropInPlace(this.workRecordCheckItemRemarks,'remarkPhotos'),'attachmentId')
                  const workRecords = {
                    ...this.form,
                    proWasteWaterQuestionSeventeenthAnswer:this.form.proWasteWaterQuestionSeventeenthAnswer?.join(),
                    proWasteGasQuestionThreeAnswer:this.form.proWasteGasQuestionThreeAnswer?.join(),
                    proWasteGasQuestionSixAnswer:this.form.proWasteGasQuestionSixAnswer?.join(),
                    proWasteWaterQuestionSevenAnswer:this.form.proWasteWaterQuestionSevenAnswer?.join(),
                    onlineMonitorQuestionTwoAnswer:this.form.onlineMonitorQuestionTwoAnswer?.join(),
                    onlineMonitorQuestionThreeAnswer:this.form.onlineMonitorQuestionThreeAnswer?.join(),
                    onlineMonitorQuestionFourAnswer:this.form.onlineMonitorQuestionFourAnswer?.join(),
                    boilerSaidQuestionThreeAnswer:this.form.boilerSaidQuestionThreeAnswer?.join(),
                    boilerSaidQuestionSevenAnswer:this.form.boilerSaidQuestionSevenAnswer?.join(),
                    odsModuleQuestionTwoAnswer:this.form.odsModuleQuestionTwoAnswer?.join(),
                    odsModuleQuestionThreeAnswer:this.form.odsModuleQuestionThreeAnswer?.join(),
                  };
                  workRecords.id = null
                  let data = {
                    workRecords: JSON.stringify(workRecords),
                    remarksList: JSON.stringify(workRecordCheckItemRemarks),
                    workRecordsId: this.form.id
                  }
                  localStorage.setItem('workRecordData',JSON.stringify(data))
                  this.$router.push({name: 'project-problemCheckTaskIndex'})
                })
                .catch((err) => {
                  Toast.fail({
                    message: `${err?.message || '操作失败，请重试'}`,
                    duration: 5000
                  });
              })
              // }
            })
            .catch(() => {
              Toast.success({
                message: '取消成功',
                duration: 3000
              });
            }).finally(()=>{
              this.subButtonLoading = false
            });
        } else {
          if (this.isCacheWork === '4') {
            Dialog.confirm({title: '确认提示', message: '是否确认修改?',})
              .then(() => {
                this.handleConfirm1()
              })
              .finally(() => {
                this.subButtonLoading = false
              });
          } else {
            Dialog.confirm({title: '确认提示', message: '是否签字？',})
              .then(() => {
                this.signModal = true // on confirm
              })
              .catch(() => {
                this.signModal = false  // on cancel
              })
              .finally(() => {
                this.subButtonLoading = false
              });
          }
        }
      } else {
        this.popup.show=true
      }
    },
    //签到
    signInAddress() {
        this.$set(this.form,'lng',this.lng)
        this.$set(this.form,'lat',this.lat)
        this.$set(this.form,'signAddress',this.signAddress)
    },
    //上传文件
    async afterRead3(file,checkItemName) {
      //此时可以自行将文件上传至服务器
      if (file.length > 1) {
        for (let i = 0; i < file.length; i++) {
          const fid = await uploadfilecommon(file[i].file, 'WORKRECORDS_SITUATION')
          file[i].status = 'done';
          file[i].message = '上传成功';
          if (fid && fid.length === 32) {
            this.workRecordCheckItemRemarks[this.workRecordCheckItemRemarks.findIndex(item => item.itemName === checkItemName)].attachmentId.push(fid)
          }
        }
      } else {
        const fid = await uploadfilecommon(file.file, 'WORKRECORDS_SITUATION')
        file.status = 'done';
        file.message = '上传成功';
        if (fid && fid.length === 32) {
          this.workRecordCheckItemRemarks[this.workRecordCheckItemRemarks.findIndex(item => item.itemName === checkItemName)].attachmentId.push(fid)
        }
      }
    },
    //删除
    beforeDelRemarkPhotos(file, detail,checkItemName) {
      if (this.isWorkId==='true' || this.isCacheWork==='1') return
      Dialog.confirm({title: '是否删除核查备注材料'})
        .then(() => {
          $.delete('deleteFile/' + this.workRecordCheckItemRemarks[this.workRecordCheckItemRemarks.findIndex(item => item.itemName === checkItemName)]?.attachmentId[detail.index])
            .then(() => {
              Toast.success('删除成功！');
              this.workRecordCheckItemRemarks[this.workRecordCheckItemRemarks.findIndex(item => item.itemName === checkItemName)].remarkPhotos.splice(detail.index, 1);
              this.workRecordCheckItemRemarks[this.workRecordCheckItemRemarks.findIndex(item => item.itemName === checkItemName)].attachmentId.splice(detail.index, 1);
              return true;
            }).catch(err => {
              Toast.fail(err.message);
              return false;
            })
        })
    },
    //文件删除示例
    // beforeDel3(file, detail) {
    //   if (this.isWorkId==='true') {
    //     return
    //   }
    //   Dialog.confirm({
    //     title: '是否删除核查材料'
    //   }).then(() => {
    //     $.delete('deleteFile/' + this.situationPhotosIds[detail.index]).then(res => {
    //       Toast.success('删除成功！');
    //       this.situationPhotos.splice(detail.index, 1);
    //       this.situationPhotosIds.splice(detail.index, 1);
    //       return true;
    //     }).catch(err => {
    //       Toast.fail(err.message);
    //       return false;
    //     })
    //
    //   })
    // },
    //图片限制
    beforeRead(file) {
      //无网络 不支持文件上传
      if (!navigator.onLine) {
        this.$toast('网络已断开，暂不支持上传');
        return false;
      }
      if (file.length > 1) {
        file.forEach(item => {
          if (item.type !== 'image/jpeg' && item.type !== 'image/png') {
            Toast('只允许上传jpg/png格式的图片！')
            return false;
          }
        })
      } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          Toast('只允许上传jpg/png格式的图片！')
          return false;
        }
      }
      return true
    },
    //开启
    opened() {
      this.loaded = false
      this.fileds = false
      this.signAddress = ''
      this.lng = 0
      this.lat = 0
      const map = this.map
      map && map.destroy();
      this.init()
    },
    //初始化地图
    init() {
      let map = new AMap.Map('container', {
        center: [121.480033, 31.236232],
        resizeEnable: true,
        zoom: 11
      });
      this.map = map
      map.plugin(['AMap.ToolBar'], function () {
        map.addControl(new AMap.ToolBar({
          position: 'LT',
          // 简易缩放模式，默认为 false
          liteStyle: false
        }));
      });
      this.getLocation();
    },
    getLocation() {
      const self = this
      const map = this.map
      AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000 * 30,
          // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
          buttonOffset: new AMap.Pixel(10, 20),
          //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          //  定位按钮的排放位置,  RB表示右下
          buttonPosition: 'RB'
        });
        map.addControl(geolocation);
        geolocation.getCurrentPosition();
        AMap.event.addListener(geolocation, 'complete', onComplete2);
        AMap.event.addListener(geolocation, 'error', onError2);

        function onComplete2(data) {
          // data是具体的定位信息
          self.loaded = true
          self.signAddress = data.formattedAddress;   //定位格式化地址
          self.lng = data.position.lng;
          self.lat = data.position.lat;
          self.setMaps();
        }

        function onError2(data) {
          console.log('error',data)   // Toast.fail('定位错误'+data.message)
          self.fileds = true  // 定位出错
        }
      });
    },
    setMaps() {

    },
    //重新定位
    getNewIp() {
      const map = this.map
      this.loaded = false
      this.signAddress = ''
      this.lng = 0
      this.lat = 0
      map && map.destroy();
      this.init()
    },
    //定位签到（前一个版本）
    // async sub() {
    //   if (!this.loaded && !this.fileds) {
    //     Toast('正在定位，请稍等...');
    //     return;
    //   }
    //   if (this.fileds) {
    //     Toast.fail('定位失败，请重新定位!');
    //     return;
    //   }
    //   var work = {
    //     id: this.workId,
    //     lng: this.lng,
    //     lat: this.lat,
    //     signAddress: this.signAddress,
    //     signTime: this.getCurrentTime(),
    //     companyName: this.companyName,
    //     companyId: this.companyId
    //   }
    //   if(this.workId===0){
    //     work.id = this.workRecords.id
    //   }
    //   if(this.isWork!=='false'){
    //     WorkRecordsStore.put(work)
    //     const workList = (await WorkRecordsStore.toArray()).sort((f, s) => s.id - f.id)
    //     this.cacheWork = workList[workList.length - 1]
    //   }
    //   this.isSign = false
    //   Toast.success('签到成功！');
    // },
    // 将base64转换为file
    dataURLtoFile(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bytes = atob(arr[1]); // 解码base64
      let n = bytes.length;
      let ia = new Uint8Array(n);
      while (n--) {
        ia[n] = bytes.charCodeAt(n);
      }
      return new File([ia], "image.jpg", {type: mime});
    },
    /**
     * 初始化缓存
     * 注：类型解释
     *      0：本地缓存（新增）
     *      1：核查记录（查看/编辑） ---> 编辑分列为 4
     *      2：云端缓存（新增）
     *      3：拷贝记录（新增）
     */
    async initCache(){
      this.isCacheWork = localStorage.getItem('isCacheWork')
      if(this.isCacheWork==='0'){ //本地缓存
        const indexdbCacheId = localStorage.getItem('indexdbCacheId')
        if(indexdbCacheId===null) return;

        const work = (await WorkRecordsStore.toArray())
          .find(record => record.id.toString() === indexdbCacheId)
        if (work != null) {
          this.workId = work.id
          this.form = {...this.form,...work}
        }
        const remarks = (await WorkRecordCheckItemRemarksStore.toArray())
          .find(record => record.id.toString() === indexdbCacheId)
        if (remarks != null) {
          this.delCache = false
          this.workRecordCheckItemRemarks = []
          JSON.parse(remarks.remarks)?.forEach(val => {
            let attachmentIds = []
            let remarkPhotos = []
            if (val.attachmentId) {
              attachmentIds = val.attachmentId.split(',')
              attachmentIds.forEach(attachmentId => remarkPhotos.push({ url: this.apiBaseURL+'/download/' + attachmentId, isImage: true }))
            }
            this.workRecordCheckItemRemarks.push({itemName:val.itemName, attachmentId:attachmentIds,remarkPhotos:remarkPhotos, remark:val.remark})
          })
          this.handleParsingCacheFormData()
        }
      } else if (this.isCacheWork==='2'){
        const cacheCode = localStorage.getItem('cloudCacheCode')
        if(!cacheCode) return;
        $.get('workRecords/getCloudCacheByCode',{
          projectId: localStorage.getItem('projectId'),
          companyId: this.companyId,
          cacheCode: cacheCode,
        }).then(res => {
          const work = JSON.parse(res.workRecords)
          if (work != null) {
            if (work.proWasteGasQuestionThreeAnswer && typeof work.proWasteGasQuestionThreeAnswer === "string") {
              work.proWasteGasQuestionThreeAnswer = JSON.parse(work.proWasteGasQuestionThreeAnswer)
            }
            if (work.proWasteGasQuestionSixAnswer && typeof work.proWasteGasQuestionSixAnswer === "string") {
              work.proWasteGasQuestionSixAnswer = JSON.parse(work.proWasteGasQuestionSixAnswer)
            }
            if (work.proWasteWaterQuestionSevenAnswer && typeof work.proWasteWaterQuestionSevenAnswer === "string") {
              work.proWasteWaterQuestionSevenAnswer = JSON.parse(work.proWasteWaterQuestionSevenAnswer)
            }
            if (work.proWasteWaterQuestionSeventeenthAnswer && typeof work.proWasteWaterQuestionSeventeenthAnswer === "string") {
              work.proWasteWaterQuestionSeventeenthAnswer = JSON.parse(work.proWasteWaterQuestionSeventeenthAnswer)
            }
            if (work.onlineMonitorQuestionTwoAnswer && typeof work.onlineMonitorQuestionTwoAnswer === "string") {
              work.onlineMonitorQuestionTwoAnswer = JSON.parse(work.onlineMonitorQuestionTwoAnswer)
            }
            if (work.onlineMonitorQuestionThreeAnswer && typeof work.onlineMonitorQuestionThreeAnswer === "string") {
              work.onlineMonitorQuestionThreeAnswer = JSON.parse(work.onlineMonitorQuestionThreeAnswer)
            }
            if (work.onlineMonitorQuestionFourAnswer && typeof work.onlineMonitorQuestionFourAnswer === "string") {
              work.onlineMonitorQuestionFourAnswer = JSON.parse(work.onlineMonitorQuestionFourAnswer)
            }
            if (work.boilerSaidQuestionThreeAnswer && typeof work.boilerSaidQuestionThreeAnswer === "string") {
              work.boilerSaidQuestionThreeAnswer = JSON.parse(work.boilerSaidQuestionThreeAnswer)
            }
            if (work.boilerSaidQuestionSevenAnswer && typeof work.boilerSaidQuestionSevenAnswer === "string") {
              work.boilerSaidQuestionSevenAnswer = JSON.parse(work.boilerSaidQuestionSevenAnswer)
            }
            if (work.odsModuleQuestionTwoAnswer && typeof work.odsModuleQuestionTwoAnswer === "string") {
              work.odsModuleQuestionTwoAnswer = JSON.parse(work.odsModuleQuestionTwoAnswer)
            }
            if (work.odsModuleQuestionThreeAnswer && typeof work.odsModuleQuestionThreeAnswer === "string") {
              work.odsModuleQuestionThreeAnswer = JSON.parse(work.odsModuleQuestionThreeAnswer)
            }
            this.workId = work.id
            this.form = {...this.form,...work}
          }
          const remarks = JSON.parse(res.remarksList)
          if (remarks != null) {
            this.delCache = false
            this.workRecordCheckItemRemarks = []
            remarks.remarks.forEach(val => {
              let attachmentIds = []
              let remarkPhotos = []
              if (val.attachmentId) {
                attachmentIds = val.attachmentId.split(',')
                attachmentIds.forEach(attachmentId => remarkPhotos.push({ url: this.apiBaseURL+'/download/' + attachmentId, isImage: true }))
              }
              this.workRecordCheckItemRemarks.push({itemName:val.itemName, attachmentId:attachmentIds,remarkPhotos:remarkPhotos, remark:val.remark})
            })
            this.handleParsingCacheFormData()
          }
        })
      } else if (this.isCacheWork==='1'){
        const work = JSON.parse(localStorage.getItem('workRecordItem'))
        if (work != null) {
          this.workId = work.id
          const status = work.approvalStatus
          this.isCacheWork = status === '0' ? '1' : '4'
          this.handleParsingViewFormData(work) //解析表单数据
          //获取一下该记录的备注列表
          $.get('workRecords/getRecordRemarksByRecordsId',{ recordsId:work.id }).then(res => {
            let remarks = []
            res?.forEach(val => {
              let attachmentIds = []
              let remarkPhotos = []
              if (val.attachmentId) {
                attachmentIds = val.attachmentId.split(',')
                attachmentIds.forEach(attachmentId => remarkPhotos.push({ url: this.apiBaseURL+'/download/' + attachmentId, isImage: true }))
              }
              remarks.push({itemName:val.itemName, attachmentId:attachmentIds,remarkPhotos:remarkPhotos, remark:val.remark})
            })
            this.workRecordCheckItemRemarks = remarks
          })
        }
      } else if (this.isCacheWork==='3') {
        const copyRecord = JSON.parse(localStorage.getItem('workRecordItem'))
        Object.assign(copyRecord,
          {
            id: null,
            lat: null,
            lng: null,
            signAddress: null,
            signPhotosId: null,
            signTime: null,
            projectName:null,
            commonCheckUser:null,
            approvalStatus:null,
            approvalOpinions:null
        });
        const copy = _.omitBy(copyRecord, _.isNil);
        this.handleParsingViewFormData(copy)

        const indexdbCacheId = localStorage.getItem('indexdbCacheId') //本地缓存数据库的id
        if(indexdbCacheId===null) return;
        const work = (await WorkRecordsStore.toArray())
          .find(record => record.id.toString() === indexdbCacheId)

        if (work != null) {
          this.workId = work.id
          this.form = {...this.form,...work}
        }
        this.delCache = false
        this.cacheLocal()
        // localStorage.removeItem('workRecordItem')
      }
    },
    //解析缓存的表单数据
    handleParsingCacheFormData(){
      //生产情况设置
      if (this.form.productionStatus?.includes('搬迁至')) {
        this.baseInfo = {
          showMoveOut:true,
          moveOutName:this.form.productionStatus.slice(3)
        }
      }
      //锅炉类型数量设置
      if (this.form.boilerSaidQuestionFourAnswer){
        this.form.boilerSaidQuestionFourAnswer.split(',').forEach(val => {
          const [text, number] = val.split(/[()]/).filter(Boolean);
          this.boilerOrSaid.boilerInfo.fuelType.push(text)
          if (text==='燃油') {this.boilerOrSaid.boilerInfo.fuelNum = number}
          if (text==='燃气') {this.boilerOrSaid.boilerInfo.gasNum = number}
          if (text==='燃生物质') {this.boilerOrSaid.boilerInfo.burningBiomassNum = number}
          if (text==='电') {this.boilerOrSaid.boilerInfo.electricalNum = number}
          if (text==='其他') {this.boilerOrSaid.boilerInfo.otherNum = number}
        })
      }
      //炉窑类型数量设置
      if (this.form.boilerSaidQuestionSixAnswer){
        this.form.boilerSaidQuestionSixAnswer.split(',').forEach(val => {
          const [text, number] = val.split(/[()]/).filter(Boolean);
          this.boilerOrSaid.furnaceInfo.fuelType.push(text)
          if (text==='加热炉') {this.boilerOrSaid.furnaceInfo.heatingFurnaceNum = number}
          if (text==='热处理炉') {this.boilerOrSaid.furnaceInfo.heatTreatmentFurnaceNum = number}
          if (text==='熔化炉') {this.boilerOrSaid.furnaceInfo.meltingFurnaceNum = number}
          if (text==='干燥炉') {this.boilerOrSaid.furnaceInfo.dryingFurnaceNum = number}
          if (text==='其他') {this.boilerOrSaid.furnaceInfo.otherNum = number}
        })
      }
      //设备类型及数量设置
      if (this.form.boilerSaidQuestionEightAnswer){
        this.form.boilerSaidQuestionEightAnswer.split(',').forEach(val => {
          const [text, number] = val.split(/[()]/).filter(Boolean);
          this.boilerOrSaid.saidInfo.deviceType.push(text)
          if (text==='柴油') {this.boilerOrSaid.saidInfo.dieselNum = number}
          if (text==='纯电') {this.boilerOrSaid.saidInfo.pureElectricNum = number}
        })
      }
    },
    //解析查询的记录数据
    handleParsingViewFormData (workRecords){
      //生产情况设置
      if (workRecords.productionStatus?.includes('搬迁至')) {
        this.baseInfo = {
          showMoveOut:true,
          moveOutName:workRecords.productionStatus.slice(3)
        }
      }
      //表单值设置
      this.form = {
        ...workRecords,
        proWasteWaterQuestionSeventeenthAnswer: workRecords.proWasteWaterQuestionSeventeenthAnswer?workRecords.proWasteWaterQuestionSeventeenthAnswer.split(','):[],
        proWasteGasQuestionThreeAnswer: workRecords.proWasteGasQuestionThreeAnswer?workRecords.proWasteGasQuestionThreeAnswer.split(','):[],
        proWasteGasQuestionSixAnswer: workRecords.proWasteGasQuestionSixAnswer?workRecords.proWasteGasQuestionSixAnswer.split(','):[],
        proWasteWaterQuestionSevenAnswer: workRecords.proWasteWaterQuestionSevenAnswer?workRecords.proWasteWaterQuestionSevenAnswer.split(','):[],
        onlineMonitorQuestionTwoAnswer: workRecords.onlineMonitorQuestionTwoAnswer?workRecords.onlineMonitorQuestionTwoAnswer.split(','):[],
        onlineMonitorQuestionThreeAnswer: workRecords.onlineMonitorQuestionThreeAnswer?workRecords.onlineMonitorQuestionThreeAnswer.split(','):[],
        onlineMonitorQuestionFourAnswer: workRecords.onlineMonitorQuestionFourAnswer?workRecords.onlineMonitorQuestionFourAnswer.split(','):[],
        boilerSaidQuestionThreeAnswer: workRecords.boilerSaidQuestionThreeAnswer?workRecords.boilerSaidQuestionThreeAnswer.split(','):[],
        boilerSaidQuestionSevenAnswer: workRecords.boilerSaidQuestionSevenAnswer?workRecords.boilerSaidQuestionSevenAnswer.split(','):[],
        odsModuleQuestionTwoAnswer: workRecords.odsModuleQuestionTwoAnswer?workRecords.odsModuleQuestionTwoAnswer.split(','):[],
        odsModuleQuestionThreeAnswer: workRecords.odsModuleQuestionThreeAnswer?workRecords.odsModuleQuestionThreeAnswer.split(','):[],
      }
      //锅炉类型数量设置
      if (workRecords.boilerSaidQuestionFourAnswer){
        workRecords.boilerSaidQuestionFourAnswer.split(',').forEach(val => {
          const [text, number] = val.split(/[()]/).filter(Boolean);
          this.boilerOrSaid.boilerInfo.fuelType.push(text)
          if (text==='燃油') {this.boilerOrSaid.boilerInfo.fuelNum = number}
          if (text==='燃气') {this.boilerOrSaid.boilerInfo.gasNum = number}
          if (text==='燃生物质') {this.boilerOrSaid.boilerInfo.burningBiomassNum = number}
          if (text==='电') {this.boilerOrSaid.boilerInfo.electricalNum = number}
          if (text==='其他') {this.boilerOrSaid.boilerInfo.otherNum = number}
        })
      }
      //炉窑类型数量设置
      if (workRecords.boilerSaidQuestionSixAnswer){
        workRecords.boilerSaidQuestionSixAnswer.split(',').forEach(val => {
          const [text, number] = val.split(/[()]/).filter(Boolean);
          this.boilerOrSaid.furnaceInfo.fuelType.push(text)
          if (text==='加热炉') {this.boilerOrSaid.furnaceInfo.heatingFurnaceNum = number}
          if (text==='热处理炉') {this.boilerOrSaid.furnaceInfo.heatTreatmentFurnaceNum = number}
          if (text==='熔化炉') {this.boilerOrSaid.furnaceInfo.meltingFurnaceNum = number}
          if (text==='干燥炉') {this.boilerOrSaid.furnaceInfo.dryingFurnaceNum = number}
          if (text==='其他') {this.boilerOrSaid.furnaceInfo.otherNum = number}
        })
      }
      //设备类型及数量设置
      if (workRecords.boilerSaidQuestionEightAnswer){
        workRecords.boilerSaidQuestionEightAnswer.split(',').forEach(val => {
          const [text, number] = val.split(/[()]/).filter(Boolean);
          this.boilerOrSaid.saidInfo.deviceType.push(text)
          if (text==='柴油') {this.boilerOrSaid.saidInfo.dieselNum = number}
          if (text==='纯电') {this.boilerOrSaid.saidInfo.pureElectricNum = number}
        })
      }
    },
    //选择行业类型
    HandleSelectIndustry () {
      if (this.isCacheWork==='1') return
      this.showSelectIndustry = true
      this.searchIndustry()
    },
    //获取行业的数组结果
    searchIndustry() {
      if (this.industryName) {
        this.selectIndustryList = this.industryList.filter(item => item.name.includes(this.industryName))
      } else {
        this.selectIndustryList = [...this.industryList]
      }
    },
    //获取应急预案日期
    HandleSelectDateTime() {
      if (this.isCacheWork==='1') return
      if (this.form.suddenEnvQuestionThreeAnswer) {
        const match = this.form.suddenEnvQuestionThreeAnswer.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (match) {
          const year = parseInt(match[1], 10);
          const day = parseInt(match[2], 10);
          const month = parseInt(match[3], 10) - 1; // 月份从0开始
          this.selectDateTime = new Date(year, month, day);
        }
      }
      this.showSelectDateTime = true
    },
    //设置选择的日期
    handleConfirmDateTime(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      this.$set(this.form,'suddenEnvQuestionThreeAnswer',`${year}-${month}-${day}`)
      this.showSelectDateTime = false;
      this.handleAutoDateTime()
    },
    //格式化时间
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;  // 格式化年：2024年
      }
      else if (type === 'month') {
        return `${val}月`;  // 格式化月：05月
      }
      else if (type === 'day') {
        return `${val}日`;  // 格式化日：01日
      }
      return val;
    },
    //自动生成时间
    handleAutoDateTime() {
      if (this.form.suddenEnvQuestionSevenAnswer && this.form.suddenEnvQuestionThreeAnswer) {
        const date = new Date(this.form.suddenEnvQuestionThreeAnswer);
        date.setFullYear(date.getFullYear() + Number(this.form.suddenEnvQuestionSevenAnswer));
        // 日期减1天
        date.setDate(date.getDate() - 1);
        const result = [
          date.getFullYear(),
          String(date.getMonth() + 1).padStart(2, '0'),
          String(date.getDate()).padStart(2, '0')
        ].join('-');
        this.$set(this.form,'suddenEnvQuestionEightAnswer',result)
      } else {
        this.$delete(this.form,'suddenEnvQuestionEightAnswer')
      }
    },
    //选中
    handleSelect(item) {
      this.selectIndustry.selectedCode = item.code === this.selectIndustry.selectedCode ? '' : item.code
      this.selectIndustry.selectedName = this.selectIndustry.selectedCode ? item.name : ''
    },
    HandleSelectIndusTryDone(){
      this.form.industryName = this.selectIndustry.selectedName
      this.handleClearSelectIndusTry()
    },
    handleClearSelectIndusTry(){
      this.showSelectIndustry = false
      this.selectIndustry = {selectedCode: '', selectedName: ''}
      this.industryName = ''
    },
    //检查要求提示
    handleCheckTips (description){
      this.sheet.showActionSheet = true
      this.sheet.description = description
    },
    //生产情况（搬迁（搬至————————））
    handleProductionStatus (name){
      if (name!=='在建' && name!=='调试期' && name!=='正常生产' && name!=='停产' && name!=='关闭' && name!=='其他' && name!=='非生产型') {
        this.baseInfo.showMoveOut=true
        if (name==='搬迁') this.form.productionStatus = '搬迁至'
      } else {
        this.baseInfo.showMoveOut=false
        this.baseInfo.moveOutName=''
      }
    },
    //选中填写值
    handleChangeRadioName (){
      this.form.productionStatus = '搬迁至' + this.baseInfo.moveOutName
    },
    //风险选择填写
    handleRisksQuestionNum (value){
      if (value===1) {
        if (this.form.potentialRisksQuestionTwoAnswer ==='否') this.form.potentialRisksQuestionTwoAnswerNum = 0
      }
      if (value===2) {
        if (this.form.potentialRisksQuestionThreeAnswer ==='否') this.form.potentialRisksQuestionThreeAnswerNum = 0
      }
      if (value===3) {
        if (this.form.potentialRisksQuestionFourAnswer ==='否') this.form.potentialRisksQuestionFourAnswerNum = 0
      }
      if (value===4) {
        if (this.form.potentialRisksQuestionFiveAnswer ==='否') this.form.potentialRisksQuestionFiveAnswerNum = 0
      }
      if (value===5) {
        if (this.form.chemSolidWasteQuestionTwentyTwoAnswer ==='否') this.form.chemSolidWasteQuestionTwentyTwoAnswerUnit = ''
      }
      if (value===6) {
        if (this.form.chemSolidWasteQuestionThirtySixAnswer ==='否') this.form.chemSolidWasteQuestionThirtySixAnswerGo = ''
      }
    },
    //锅炉|非道路 选择填写
    handleBoilerSaidCheckboxChange(num){
      if (num===1) {
        this.setBoilerSaidQuestionFourAnswer()
      }
      if (num===2) {
        this.setBoilerSaidQuestionSixAnswer()
      }
      if (num===3) {
        this.setBoilerSaidQuestionEightAnswer()
      }
    },
    //设置值
    setBoilerSaidQuestionFourAnswer(){
      const questionFourAnswer = []
      this.boilerOrSaid.boilerInfo.fuelType.forEach(str=>{
        if (str==='燃油'){
          questionFourAnswer.push('燃油('+this.boilerOrSaid.boilerInfo.fuelNum+')')
        }
        if (str==='燃气'){
          questionFourAnswer.push('燃气('+this.boilerOrSaid.boilerInfo.gasNum+')')
        }
        if (str==='燃生物质'){
          questionFourAnswer.push('燃生物质('+this.boilerOrSaid.boilerInfo.burningBiomassNum+')')
        }
        if (str==='电'){
          questionFourAnswer.push('电('+this.boilerOrSaid.boilerInfo.electricalNum+')')
        }
        if (str==='其他'){
          questionFourAnswer.push('其他('+this.boilerOrSaid.boilerInfo.otherNum+')')
        }
      })
      this.form.boilerSaidQuestionFourAnswer = questionFourAnswer?.join()
    },
    setBoilerSaidQuestionSixAnswer(){
      const questionSixAnswer = []
      this.boilerOrSaid.furnaceInfo.fuelType.forEach(str=>{
        if (str==='加热炉'){
          questionSixAnswer.push('加热炉('+this.boilerOrSaid.furnaceInfo.heatingFurnaceNum+')')
        }
        if (str==='热处理炉'){
          questionSixAnswer.push('热处理炉('+this.boilerOrSaid.furnaceInfo.heatTreatmentFurnaceNum+')')
        }
        if (str==='熔化炉'){
          questionSixAnswer.push('熔化炉('+this.boilerOrSaid.furnaceInfo.meltingFurnaceNum+')')
        }
        if (str==='干燥炉'){
          questionSixAnswer.push('干燥炉('+this.boilerOrSaid.furnaceInfo.dryingFurnaceNum+')')
        }
        if (str==='其他'){
          questionSixAnswer.push('其他('+this.boilerOrSaid.furnaceInfo.otherNum+')')
        }
      })
      this.form.boilerSaidQuestionSixAnswer = questionSixAnswer?.join()
    },
    setBoilerSaidQuestionEightAnswer(){
      const questionEightAnswer = []
      this.boilerOrSaid.saidInfo.deviceType.forEach(str=>{
        if (str==='柴油'){
          questionEightAnswer.push('柴油('+this.boilerOrSaid.saidInfo.dieselNum+')')
        }
        if (str==='纯电'){
          questionEightAnswer.push('纯电('+this.boilerOrSaid.saidInfo.pureElectricNum+')')
        }
      })
      this.form.boilerSaidQuestionEightAnswer = questionEightAnswer?.join()
    },
    //判断是否选中
    isCheckBox(num,name){
      if (num===1) return this.boilerOrSaid.boilerInfo.fuelType?.includes(name);
      if (num===2) return this.boilerOrSaid.furnaceInfo.fuelType?.includes(name);
      if (num===3) return this.boilerOrSaid.saidInfo.deviceType?.includes(name);
    },
    //选中
    handleBoilerSaidCheckboxChangeNum (num) {
      if (num===1) {
        this.setBoilerSaidQuestionFourAnswer()
      }
      if (num===2) {
        this.setBoilerSaidQuestionSixAnswer()
      }
      if (num===3) {
        this.setBoilerSaidQuestionEightAnswer()
      }
    },
    //添加检查项目备注
    addRemarks(itemName){
      if (this.isCacheWork==='1') return
      const targetIndex = this.workRecordCheckItemRemarks.findIndex(item => item.itemName === itemName)
      const hasItem = targetIndex !== -1;
      if (hasItem) {
        const targetItem = this.workRecordCheckItemRemarks[targetIndex];
        const hasContent = targetItem.remark || (targetItem.remarkPhotos && targetItem.remarkPhotos.length > 0);
        if (hasContent) {
          this.workRecordCheckItemRemarks.splice(targetIndex, 1, {...targetItem, show: targetItem.hasOwnProperty('show') ? !targetItem.show : false});
        } else {
          this.workRecordCheckItemRemarks.splice(targetIndex, 1);
        }
      } else {
        this.workRecordCheckItemRemarks.push({itemName: itemName, attachmentId: [], remarkPhotos: [], remark: ''});
      }
    },
    //删除检查项目备注
    delRemarks(itemName){
      if (this.workRecordCheckItemRemarks.some(item => item.itemName === itemName)) {
        this.workRecordCheckItemRemarks.splice(this.workRecordCheckItemRemarks.findIndex(item => item.itemName === itemName), 1);
      }
    },
    //是否存在
    isRemarks(itemName){
      const targetIndex = this.workRecordCheckItemRemarks.findIndex(item => item.itemName === itemName)
      if (targetIndex === -1) return false;
      const targetItem = this.workRecordCheckItemRemarks[targetIndex]
      return targetItem.hasOwnProperty('show') ? targetItem.show : true
    },
    //下一步
    handleNextCheckItem(){
      if (this.PRODUCTION_NORMAL) {
        if (this.tabVale==='basicInfo') return this.tabVale ='envPermit';
        if (this.tabVale==='envPermit') return this.tabVale ='potentialRisks';
        if (this.tabVale==='potentialRisks') return this.tabVale ='proWasteGas';
        if (this.tabVale==='proWasteGas') return this.tabVale ='proWasteWater';
        if (this.tabVale==='proWasteWater') return this.tabVale ='chemSolidWaste';
        if (this.tabVale==='chemSolidWaste') return this.tabVale ='soilGroundwater';
        if (this.tabVale==='soilGroundwater') return this.tabVale ='selfMonitor';
        if (this.tabVale==='selfMonitor') return this.tabVale ='onlineMonitor';
        if (this.tabVale==='onlineMonitor') return this.tabVale ='suddenEnvIncidents';
        if (this.tabVale==='suddenEnvIncidents') return this.tabVale ='odsModule';
        if (this.tabVale==='odsModule') return this.tabVale ='boilerKilnFeiSaid';
        if (this.tabVale==='boilerKilnFeiSaid') return this.tabVale ='administrativePenalty';
        if (this.tabVale==='administrativePenalty') return this.tabVale ='onSiteSituation';
      } else {
        if (this.tabVale==='basicInfo') return this.tabVale ='onSiteSituation';
      }
    },
    getEnvPermitQuestionSevenAnswerList(){
      return this.form.envPermitQuestionSixAnswer?this.form.envPermitQuestionSixAnswer==='已落实'?PROTOCOL.ILLEGAL_CIRCUMSTANCES1:PROTOCOL.ILLEGAL_CIRCUMSTANCES2:PROTOCOL.ILLEGAL_CIRCUMSTANCES
    },
    //检测是否完成试题
    handleDetectionCheckCompleted(){
      if (this.PRODUCTION_NORMAL) {
        this.completionList[0].option = this.checkCompletedOne()
        this.completionList[1].option = this.checkCompletedTwo()
        this.completionList[2].option = this.checkCompletedThree()
        this.completionList[3].option = this.checkCompletedFour()
        this.completionList[4].option = this.checkCompletedFive()
        this.completionList[5].option = this.checkCompletedSix()
        this.completionList[6].option = this.checkCompletedSeven()
        this.completionList[7].option = this.checkCompletedEight()
        this.completionList[8].option = this.checkCompletedNine()
        this.completionList[9].option = this.checkCompletedTen()
        this.completionList[10].option = this.checkCompletedODS()
        this.completionList[11].option = this.checkCompletedEleventh()
        this.completionList[12].option = this.checkCompletedDecember()
        return this.completionList.every(item => item.option === true);
      } else {
        this.completionList2[0].option = this.checkCompletedOne2()
        return this.completionList2.every(item => item.option === true);
      }
    },
    //检查完成情况
    checkCompletedOne(){
      return !!(this.isStringExist(this.form.companyAlias) && this.isStringExist(this.form.companyAddress) && this.isStringExist(this.form.industryName) &&
        this.isStringExist(this.form.thisContact) && this.isStringExist(this.form.contactPhone) && this.isStringExist(this.form.commonCheckUser) &&
        this.isStringExist(this.form.productionStatus) && this.isStringExist(this.form.process) && this.isStringExist(this.form.produced));
    },
    checkCompletedOne2(){
      let completed = true
      if (this.isStringExist(this.form.companyAlias) && this.isStringExist(this.form.companyAddress) && this.isStringExist(this.form.industryName) && this.isStringExist(this.form.thisContact) && this.isStringExist(this.form.contactPhone) && this.isStringExist(this.form.commonCheckUser) && this.isStringExist(this.form.productionStatus)) {
        NO_CHECK_QUESTION.forEach(key => {
          this.$delete(this.form, key)
          this.delRemarks(key)
        })
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedTwo(){
      let completed = true
      if (this.form.envPermitQuestionOneAnswer) {
        if (this.form.envPermitQuestionOneAnswer==='已落实') {
          if (!this.form.envPermitQuestionTwoAnswer || !this.form.envPermitQuestionThreeAnswer) completed = false
        } else {
          this.$delete(this.form,'envPermitQuestionTwoAnswer')
          this.$delete(this.form,'envPermitQuestionThreeAnswer')
          this.delRemarks('envPermitQuestionTwoAnswer')
          this.delRemarks('envPermitQuestionThreeAnswer')
        }
      } else {
        completed = false
      }
      if (this.form.envPermitQuestionFourAnswer) {
        if (this.form.envPermitQuestionFourAnswer==='已落实') {
          if (!this.form.envPermitQuestionFiveAnswer) completed = false
        } else {
          this.$delete(this.form,'envPermitQuestionFiveAnswer')
          this.delRemarks('envPermitQuestionFiveAnswer')
        }
      } else {
        completed = false
      }
      if (this.form.envPermitQuestionSixAnswer && this.form.envPermitQuestionEightAnswer) {
        if (this.form.envPermitQuestionSixAnswer!=='豁免') {
          if (!this.form.envPermitQuestionSevenAnswer) completed = false
        } else {
          this.$delete(this.form,'envPermitQuestionSevenAnswer')
          this.delRemarks('envPermitQuestionSevenAnswer')
        }
        if (this.form.envPermitQuestionEightAnswer==='未建立') {
          if (!this.form.envPermitQuestionNineAnswer || !this.form.envPermitQuestionTenAnswer || !this.form.envPermitQuestionEleventhAnswer ||
            !this.form.envPermitQuestionDecemberAnswer || !this.form.envPermitQuestionThirteenthAnswer || !this.form.envPermitQuestionFourteenthAnswer ||
            !this.form.envPermitQuestionFifteenAnswer || !this.form.envPermitQuestionSixteenthAnswer || !this.form.envPermitQuestionSeventeenthAnswer ||
            !this.form.envPermitQuestionEighteenAnswer || !this.form.envPermitQuestionNineteenthAnswer || !this.form.envPermitQuestionTwentyAnswer ||
            !this.form.envPermitQuestionTwentyOneAnswer || !this.form.envPermitQuestionTwentyTwoAnswer || !this.form.envPermitQuestionTwentyThreeAnswer ||
            !this.form.envPermitQuestionTwentyFourAnswer || !this.form.envPermitQuestionTwentyFiveAnswer) completed = false
        } else {
          this.$delete(this.form,'envPermitQuestionNineAnswer')
          this.$delete(this.form,'envPermitQuestionTenAnswer')
          this.$delete(this.form,'envPermitQuestionEleventhAnswer')
          this.$delete(this.form,'envPermitQuestionDecemberAnswer')
          this.$delete(this.form,'envPermitQuestionThirteenthAnswer')
          this.$delete(this.form,'envPermitQuestionFourteenthAnswer')
          this.$delete(this.form,'envPermitQuestionFifteenAnswer')
          this.$delete(this.form,'envPermitQuestionSixteenthAnswer')
          this.$delete(this.form,'envPermitQuestionSeventeenthAnswer')
          this.$delete(this.form,'envPermitQuestionEighteenAnswer')
          this.$delete(this.form,'envPermitQuestionNineteenthAnswer')
          this.$delete(this.form,'envPermitQuestionTwentyAnswer')
          this.$delete(this.form,'envPermitQuestionTwentyOneAnswer')
          this.$delete(this.form,'envPermitQuestionTwentyTwoAnswer')
          this.$delete(this.form,'envPermitQuestionTwentyThreeAnswer')
          this.$delete(this.form,'envPermitQuestionTwentyFourAnswer')
          this.$delete(this.form,'envPermitQuestionTwentyFiveAnswer')
          this.delRemarks('envPermitQuestionNineAnswer')
          this.delRemarks('envPermitQuestionTenAnswer')
          this.delRemarks('envPermitQuestionEleventhAnswer')
          this.delRemarks('envPermitQuestionDecemberAnswer')
          this.delRemarks('envPermitQuestionThirteenthAnswer')
          this.delRemarks('envPermitQuestionFourteenthAnswer')
          this.delRemarks('envPermitQuestionFifteenAnswer')
          this.delRemarks('envPermitQuestionSixteenthAnswer')
          this.delRemarks('envPermitQuestionSeventeenthAnswer')
          this.delRemarks('envPermitQuestionEighteenAnswer')
          this.delRemarks('envPermitQuestionNineteenthAnswer')
          this.delRemarks('envPermitQuestionTwentyAnswer')
          this.delRemarks('envPermitQuestionTwentyOneAnswer')
          this.delRemarks('envPermitQuestionTwentyTwoAnswer')
          this.delRemarks('envPermitQuestionTwentyThreeAnswer')
          this.delRemarks('envPermitQuestionTwentyFourAnswer')
          this.delRemarks('envPermitQuestionTwentyFiveAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedThree(){
      let completed = true
      if (this.form.potentialRisksQuestionOneAnswer) {
        if (this.form.potentialRisksQuestionOneAnswer==='涉及') {
          if (this.form.potentialRisksQuestionTwoAnswer && this.form.potentialRisksQuestionThreeAnswer && this.form.potentialRisksQuestionFourAnswer && this.form.potentialRisksQuestionFiveAnswer && this.form.potentialRisksQuestionSixAnswer && this.form.potentialRisksQuestionSevenAnswer && this.form.potentialRisksQuestionEightAnswer && this.form.potentialRisksQuestionNineAnswer) {
            if (this.form.potentialRisksQuestionTwoAnswer === '是') {
              if (!this.form.potentialRisksQuestionTwoAnswerNum) completed = false
            } else {
              this.$delete(this.form,'potentialRisksQuestionTwoAnswerNum')
            }
            if (this.form.potentialRisksQuestionThreeAnswer === '是') {
              if (!this.form.potentialRisksQuestionThreeAnswerNum) completed = false
            } else {
              this.$delete(this.form,'potentialRisksQuestionThreeAnswerNum')
            }
            if (this.form.potentialRisksQuestionFourAnswer === '是') {
              if (!this.form.potentialRisksQuestionFourAnswerNum) completed = false
            } else {
              this.$delete(this.form,'potentialRisksQuestionFourAnswerNum')
            }
            if (this.form.potentialRisksQuestionFiveAnswer === '是') {
              if (!this.form.potentialRisksQuestionFiveAnswerNum) completed = false
            } else {
              this.$delete(this.form,'potentialRisksQuestionFiveAnswerNum')
            }
          } else {
            completed = false
          }
        } else {
          this.$delete(this.form,'potentialRisksQuestionTwoAnswer')
          this.$delete(this.form,'potentialRisksQuestionTwoAnswerNum')
          this.$delete(this.form,'potentialRisksQuestionThreeAnswer')
          this.$delete(this.form,'potentialRisksQuestionThreeAnswerNum')
          this.$delete(this.form,'potentialRisksQuestionFourAnswer')
          this.$delete(this.form,'potentialRisksQuestionFourAnswerNum')
          this.$delete(this.form,'potentialRisksQuestionFiveAnswer')
          this.$delete(this.form,'potentialRisksQuestionFiveAnswerNum')
          this.$delete(this.form,'potentialRisksQuestionSixAnswer')
          this.$delete(this.form,'potentialRisksQuestionSevenAnswer')
          this.$delete(this.form,'potentialRisksQuestionEightAnswer')
          this.$delete(this.form,'potentialRisksQuestionNineAnswer')
          this.delRemarks('potentialRisksQuestionTwoAnswer')
          this.delRemarks('potentialRisksQuestionThreeAnswer')
          this.delRemarks('potentialRisksQuestionFourAnswer')
          this.delRemarks('potentialRisksQuestionFiveAnswer')
          this.delRemarks('potentialRisksQuestionSixAnswer')
          this.delRemarks('potentialRisksQuestionSevenAnswer')
          this.delRemarks('potentialRisksQuestionEightAnswer')
          this.delRemarks('potentialRisksQuestionNineAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedFour(){
      let completed = true
      if (this.form.proWasteGasQuestionOneAnswer) {
        if (this.form.proWasteGasQuestionOneAnswer==='涉及') {
          if (this.isStringExist(this.form.proWasteGasQuestionTwoAnswer) && this.form.proWasteGasQuestionThreeAnswer?.length>0 && this.form.proWasteGasQuestionFourAnswer &&
            this.form.proWasteGasQuestionFiveAnswer && this.form.proWasteGasQuestionNineAnswer && this.form.proWasteGasQuestionTenAnswer && this.form.proWasteGasQuestionEleventhAnswer &&
            this.form.proWasteGasQuestionDecemberAnswer && this.form.proWasteGasQuestionFourteenthAnswer) {
            if (this.form.proWasteGasQuestionFiveAnswer === '是') {
              if (!this.form.proWasteGasQuestionSixAnswer?.length>0 || !this.form.proWasteGasQuestionSevenAnswer || !this.form.proWasteGasQuestionEightAnswer) completed = false
            } else {
              this.$delete(this.form,'proWasteGasQuestionSixAnswer')
              this.$delete(this.form,'proWasteGasQuestionSevenAnswer')
              this.$delete(this.form,'proWasteGasQuestionEightAnswer')
              this.delRemarks('proWasteGasQuestionSixAnswer')
              this.delRemarks('proWasteGasQuestionSevenAnswer')
              this.delRemarks('proWasteGasQuestionEightAnswer')
            }
            if (this.form.proWasteGasQuestionDecemberAnswer === '是') {
              if (!this.form.proWasteGasQuestionThirteenthAnswer) completed = false
            } else {
              this.$delete(this.form,'proWasteGasQuestionThirteenthAnswer')
              this.delRemarks('proWasteGasQuestionThirteenthAnswer')
            }
            if (this.form.proWasteGasQuestionFourteenthAnswer === '是') {
              if (!this.form.proWasteGasQuestionFifteenAnswer) completed = false
            } else {
              this.$delete(this.form,'proWasteGasQuestionFifteenAnswer')
              this.delRemarks('proWasteGasQuestionFifteenAnswer')
            }
          } else {
            completed = false
          }
        } else {
          this.$delete(this.form,'proWasteGasQuestionTwoAnswer')
          this.$delete(this.form,'proWasteGasQuestionThreeAnswer')
          this.$delete(this.form,'proWasteGasQuestionFourAnswer')
          this.$delete(this.form,'proWasteGasQuestionFiveAnswer')
          this.$delete(this.form,'proWasteGasQuestionSixAnswer')
          this.$delete(this.form,'proWasteGasQuestionSevenAnswer')
          this.$delete(this.form,'proWasteGasQuestionEightAnswer')
          this.$delete(this.form,'proWasteGasQuestionNineAnswer')
          this.$delete(this.form,'proWasteGasQuestionTenAnswer')
          this.$delete(this.form,'proWasteGasQuestionEleventhAnswer')
          this.$delete(this.form,'proWasteGasQuestionDecemberAnswer')
          this.$delete(this.form,'proWasteGasQuestionThirteenthAnswer')
          this.$delete(this.form,'proWasteGasQuestionFourteenthAnswer')
          this.$delete(this.form,'proWasteGasQuestionFifteenAnswer')
          this.delRemarks('proWasteGasQuestionTwoAnswer')
          this.delRemarks('proWasteGasQuestionThreeAnswer')
          this.delRemarks('proWasteGasQuestionFourAnswer')
          this.delRemarks('proWasteGasQuestionFiveAnswer')
          this.delRemarks('proWasteGasQuestionSixAnswer')
          this.delRemarks('proWasteGasQuestionSevenAnswer')
          this.delRemarks('proWasteGasQuestionEightAnswer')
          this.delRemarks('proWasteGasQuestionNineAnswer')
          this.delRemarks('proWasteGasQuestionTenAnswer')
          this.delRemarks('proWasteGasQuestionEleventhAnswer')
          this.delRemarks('proWasteGasQuestionDecemberAnswer')
          this.delRemarks('proWasteGasQuestionThirteenthAnswer')
          this.delRemarks('proWasteGasQuestionFourteenthAnswer')
          this.delRemarks('proWasteGasQuestionFifteenAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedFive(){
      let completed = true
      if (this.form.proWasteWaterQuestionOneAnswer) {
        if (this.form.proWasteWaterQuestionOneAnswer==='涉及') {
          if (this.isStringExist(this.form.proWasteWaterQuestionTwoAnswer) && this.form.proWasteWaterQuestionThreeAnswer && this.form.proWasteWaterQuestionFiveAnswer && this.form.proWasteWaterQuestionSixAnswer && this.form.proWasteWaterQuestionTenAnswer && this.form.proWasteWaterQuestionEleventhAnswer &&
            this.form.proWasteWaterQuestionDecemberAnswer && this.form.proWasteWaterQuestionThirteenthAnswer && this.form.proWasteWaterQuestionFourteenthAnswer && this.form.proWasteWaterQuestionFifteenAnswer && this.form.proWasteWaterQuestionSeventeenthAnswer?.length>0) {
            if (this.form.proWasteWaterQuestionThreeAnswer === '是') {
              if (!this.isStringExist(this.form.proWasteWaterQuestionFourAnswer)) completed = false
            } else {
              this.$delete(this.form,'proWasteWaterQuestionFourAnswer')
              this.delRemarks('proWasteWaterQuestionFourAnswer')
            }
            if (this.form.proWasteWaterQuestionSixAnswer === '是') {
              if (this.form.proWasteWaterQuestionSevenAnswer?.length>0 && this.form.proWasteWaterQuestionEightAnswer && this.form.proWasteWaterQuestionNineAnswer) {
                if (this.form.proWasteWaterQuestionSevenAnswer.some(val => val === '其他')) {
                  if (!this.isStringExist(this.form.proWasteWaterQuestionSevenAnswerOther)) completed = false
                } else {
                  this.$delete(this.form,'proWasteWaterQuestionSevenAnswerOther')
                }
              } else {
                completed = false
              }
            } else {
              this.$delete(this.form,'proWasteWaterQuestionSevenAnswer')
              this.$delete(this.form,'proWasteWaterQuestionEightAnswer')
              this.$delete(this.form,'proWasteWaterQuestionNineAnswer')
              this.$delete(this.form,'proWasteWaterQuestionSevenAnswerOther')
              this.delRemarks('proWasteWaterQuestionSevenAnswer')
              this.delRemarks('proWasteWaterQuestionEightAnswer')
              this.delRemarks('proWasteWaterQuestionNineAnswer')
            }
            if (this.form.proWasteWaterQuestionFifteenAnswer === '是') {
              if (!this.form.proWasteWaterQuestionSixteenAnswer) completed = false
            } else {
              this.$delete(this.form,'proWasteWaterQuestionSixteenAnswer')
              this.delRemarks('proWasteWaterQuestionSixteenAnswer')
            }
          } else {
            completed = false
          }
        } else {
          this.$delete(this.form,'proWasteWaterQuestionTwoAnswer')
          this.$delete(this.form,'proWasteWaterQuestionThreeAnswer')
          this.$delete(this.form,'proWasteWaterQuestionFourAnswer')
          this.$delete(this.form,'proWasteWaterQuestionFiveAnswer')
          this.$delete(this.form,'proWasteWaterQuestionSixAnswer')
          this.$delete(this.form,'proWasteWaterQuestionSevenAnswer')
          this.$delete(this.form,'proWasteWaterQuestionSevenAnswerOther')
          this.$delete(this.form,'proWasteWaterQuestionEightAnswer')
          this.$delete(this.form,'proWasteWaterQuestionNineAnswer')
          this.$delete(this.form,'proWasteWaterQuestionTenAnswer')
          this.$delete(this.form,'proWasteWaterQuestionEleventhAnswer')
          this.$delete(this.form,'proWasteWaterQuestionDecemberAnswer')
          this.$delete(this.form,'proWasteWaterQuestionThirteenthAnswer')
          this.$delete(this.form,'proWasteWaterQuestionFourteenthAnswer')
          this.$delete(this.form,'proWasteWaterQuestionFifteenAnswer')
          this.$delete(this.form,'proWasteWaterQuestionSixteenAnswer')
          this.$delete(this.form,'proWasteWaterQuestionSeventeenthAnswer')
          this.delRemarks('proWasteWaterQuestionTwoAnswer')
          this.delRemarks('proWasteWaterQuestionThreeAnswer')
          this.delRemarks('proWasteWaterQuestionFourAnswer')
          this.delRemarks('proWasteWaterQuestionFiveAnswer')
          this.delRemarks('proWasteWaterQuestionSixAnswer')
          this.delRemarks('proWasteWaterQuestionSevenAnswer')
          this.delRemarks('proWasteWaterQuestionSevenAnswerOther')
          this.delRemarks('proWasteWaterQuestionEightAnswer')
          this.delRemarks('proWasteWaterQuestionNineAnswer')
          this.delRemarks('proWasteWaterQuestionTenAnswer')
          this.delRemarks('proWasteWaterQuestionEleventhAnswer')
          this.delRemarks('proWasteWaterQuestionDecemberAnswer')
          this.delRemarks('proWasteWaterQuestionThirteenthAnswer')
          this.delRemarks('proWasteWaterQuestionFourteenthAnswer')
          this.delRemarks('proWasteWaterQuestionFifteenAnswer')
          this.delRemarks('proWasteWaterQuestionSixteenAnswer')
          this.delRemarks('proWasteWaterQuestionSeventeenthAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedSix(){
      let completed = true
      if (this.form.chemSolidWasteQuestionOneAnswer && this.form.chemSolidWasteQuestionTwoAnswer && this.form.chemSolidWasteQuestionThreeAnswer) {
        if (this.form.chemSolidWasteQuestionOneAnswer === '涉及') {
          if (!this.form.chemSolidWasteQuestionFourAnswer || !this.form.chemSolidWasteQuestionFiveAnswer || !this.form.chemSolidWasteQuestionSixAnswer || !this.form.chemSolidWasteQuestionSevenAnswer || !this.form.chemSolidWasteQuestionEightAnswer) {
            completed = false
          }
        } else {
          this.$delete(this.form, 'chemSolidWasteQuestionFourAnswer')
          this.$delete(this.form, 'chemSolidWasteQuestionFiveAnswer')
          this.$delete(this.form, 'chemSolidWasteQuestionSixAnswer')
          this.$delete(this.form, 'chemSolidWasteQuestionSevenAnswer')
          this.$delete(this.form, 'chemSolidWasteQuestionEightAnswer')
          this.delRemarks('chemSolidWasteQuestionFourAnswer')
          this.delRemarks('chemSolidWasteQuestionFiveAnswer')
          this.delRemarks('chemSolidWasteQuestionSixAnswer')
          this.delRemarks('chemSolidWasteQuestionSevenAnswer')
          this.delRemarks('chemSolidWasteQuestionEightAnswer')
        }
        if (this.form.chemSolidWasteQuestionTwoAnswer==='涉及') {
          if (this.form.chemSolidWasteQuestionNineAnswer && this.isStringExist(this.form.chemSolidWasteQuestionTenAnswer) && this.form.chemSolidWasteQuestionEleventhAnswer && this.form.chemSolidWasteQuestionDecemberAnswer && this.form.chemSolidWasteQuestionThirteenthAnswer && this.form.chemSolidWasteQuestionFourteenthAnswer && this.form.chemSolidWasteQuestionFifteenAnswer && this.form.chemSolidWasteQuestionSixteenAnswer && this.form.chemSolidWasteQuestionSeventeenthAnswer && this.form.chemSolidWasteQuestionEighteenAnswer && this.form.chemSolidWasteQuestionNineteenthAnswer && this.form.chemSolidWasteQuestionTwentyAnswer && this.form.chemSolidWasteQuestionTwentyOneAnswer && this.form.chemSolidWasteQuestionTwentyTwoAnswer) {
            if (this.form.chemSolidWasteQuestionTwentyTwoAnswer==='是') {
              if (!this.isStringExist(this.form.chemSolidWasteQuestionTwentyTwoAnswerUnit)) completed = false;
            } else {
              this.$delete(this.form,'chemSolidWasteQuestionTwentyTwoAnswerUnit')
            }
          } else {
            completed = false
          }
        } else {
          this.$delete(this.form,'chemSolidWasteQuestionNineAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTenAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionEleventhAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionDecemberAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionThirteenthAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionFourteenthAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionFifteenAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionSixteenAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionSeventeenthAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionEighteenAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionNineteenthAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTwentyAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTwentyOneAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTwentyTwoAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTwentyTwoAnswerUnit')
          this.delRemarks('chemSolidWasteQuestionNineAnswer')
          this.delRemarks('chemSolidWasteQuestionTenAnswer')
          this.delRemarks('chemSolidWasteQuestionEleventhAnswer')
          this.delRemarks('chemSolidWasteQuestionDecemberAnswer')
          this.delRemarks('chemSolidWasteQuestionThirteenthAnswer')
          this.delRemarks('chemSolidWasteQuestionFourteenthAnswer')
          this.delRemarks('chemSolidWasteQuestionFifteenAnswer')
          this.delRemarks('chemSolidWasteQuestionSixteenAnswer')
          this.delRemarks('chemSolidWasteQuestionSeventeenthAnswer')
          this.delRemarks('chemSolidWasteQuestionEighteenAnswer')
          this.delRemarks('chemSolidWasteQuestionNineteenthAnswer')
          this.delRemarks('chemSolidWasteQuestionTwentyAnswer')
          this.delRemarks('chemSolidWasteQuestionTwentyOneAnswer')
          this.delRemarks('chemSolidWasteQuestionTwentyTwoAnswer')
        }
        if (this.form.chemSolidWasteQuestionThreeAnswer==='涉及') {
          if (this.form.chemSolidWasteQuestionTwentyThreeAnswer && this.form.chemSolidWasteQuestionTwentyFourAnswer && this.form.chemSolidWasteQuestionTwentyFiveAnswer && this.form.chemSolidWasteQuestionTwentySixAnswer && this.form.chemSolidWasteQuestionTwentySevenAnswer &&
            this.form.chemSolidWasteQuestionTwentyEightAnswer && this.form.chemSolidWasteQuestionTwentyNineAnswer && this.form.chemSolidWasteQuestionThirtyAnswer && this.form.chemSolidWasteQuestionThirtyOneAnswer && this.form.chemSolidWasteQuestionThirtyTwoAnswer && this.form.chemSolidWasteQuestionThirtyThreeAnswer &&
            this.form.chemSolidWasteQuestionThirtyFourAnswer && this.form.chemSolidWasteQuestionThirtyFiveAnswer && this.form.chemSolidWasteQuestionThirtySixAnswer && this.form.chemSolidWasteQuestionThirtySevenAnswer) {
            if (this.form.chemSolidWasteQuestionThirtySixAnswer==='是') {
              if (!this.isStringExist(this.form.chemSolidWasteQuestionThirtySixAnswerGo)) completed = false;
            } else {
              this.$delete(this.form,'chemSolidWasteQuestionThirtySixAnswerGo')
            }
          } else {
            completed = false
          }
        } else {
          this.$delete(this.form,'chemSolidWasteQuestionTwentyThreeAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTwentyFourAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTwentyFiveAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTwentySixAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTwentySevenAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTwentyEightAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionTwentyNineAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionThirtyAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionThirtyOneAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionThirtyTwoAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionThirtyThreeAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionThirtyFourAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionThirtyFiveAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionThirtySixAnswer')
          this.$delete(this.form,'chemSolidWasteQuestionThirtySixAnswerGo')
          this.$delete(this.form,'chemSolidWasteQuestionThirtySevenAnswer')
          this.delRemarks('chemSolidWasteQuestionTwentyThreeAnswer')
          this.delRemarks('chemSolidWasteQuestionTwentyFourAnswer')
          this.delRemarks('chemSolidWasteQuestionTwentyFiveAnswer')
          this.delRemarks('chemSolidWasteQuestionTwentySixAnswer')
          this.delRemarks('chemSolidWasteQuestionTwentySevenAnswer')
          this.delRemarks('chemSolidWasteQuestionTwentyEightAnswer')
          this.delRemarks('chemSolidWasteQuestionTwentyNineAnswer')
          this.delRemarks('chemSolidWasteQuestionThirtyAnswer')
          this.delRemarks('chemSolidWasteQuestionThirtyOneAnswer')
          this.delRemarks('chemSolidWasteQuestionThirtyTwoAnswer')
          this.delRemarks('chemSolidWasteQuestionThirtyThreeAnswer')
          this.delRemarks('chemSolidWasteQuestionThirtyFourAnswer')
          this.delRemarks('chemSolidWasteQuestionThirtyFiveAnswer')
          this.delRemarks('chemSolidWasteQuestionThirtySixAnswer')
          this.delRemarks('chemSolidWasteQuestionThirtySevenAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedSeven(){
      let completed = true
      if (this.form.soilGroundwaterQuestionOneAnswer) {
        if (this.form.soilGroundwaterQuestionOneAnswer==='涉及') {
          if (!this.form.soilGroundwaterQuestionTwoAnswer || !this.form.soilGroundwaterQuestionThreeAnswer || !this.form.soilGroundwaterQuestionFourAnswer) completed = false
        } else {
          this.$delete(this.form,'soilGroundwaterQuestionTwoAnswer')
          this.$delete(this.form,'soilGroundwaterQuestionThreeAnswer')
          this.$delete(this.form,'soilGroundwaterQuestionFourAnswer')
          this.delRemarks('soilGroundwaterQuestionTwoAnswer')
          this.delRemarks('soilGroundwaterQuestionThreeAnswer')
          this.delRemarks('soilGroundwaterQuestionFourAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedEight(){
      let completed = true
      if (this.form.selfMonitorQuestionOneAnswer) {
        if (this.form.selfMonitorQuestionOneAnswer==='涉及') {
          if (!this.form.selfMonitorQuestionTwoAnswer || !this.form.selfMonitorQuestionThreeAnswer || !this.form.selfMonitorQuestionFourAnswer) completed = false
        } else {
          this.$delete(this.form,'selfMonitorQuestionTwoAnswer')
          this.$delete(this.form,'selfMonitorQuestionThreeAnswer')
          this.$delete(this.form,'selfMonitorQuestionFourAnswer')
          this.delRemarks('selfMonitorQuestionTwoAnswer')
          this.delRemarks('selfMonitorQuestionThreeAnswer')
          this.delRemarks('selfMonitorQuestionFourAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedNine(){
      let completed = true
      if (this.form.onlineMonitorQuestionOneAnswer) {
        if (this.form.onlineMonitorQuestionOneAnswer==='涉及') {
          if (this.form.onlineMonitorQuestionTwoAnswer?.length>0 && this.form.onlineMonitorQuestionFiveAnswer && this.form.onlineMonitorQuestionSixAnswer) {
            if (this.form.onlineMonitorQuestionTwoAnswer.some(val=>val==='废水')) {
              if (!this.form.onlineMonitorQuestionThreeAnswer?.length>0) completed = false
            } else {
              this.$delete(this.form,'onlineMonitorQuestionThreeAnswer')
              this.delRemarks('onlineMonitorQuestionThreeAnswer')
            }
            if (this.form.onlineMonitorQuestionTwoAnswer.some(val=>val==='废气')) {
              if (!this.form.onlineMonitorQuestionFourAnswer?.length>0) completed = false
            } else {
              this.$delete(this.form,'onlineMonitorQuestionFourAnswer')
              this.delRemarks('onlineMonitorQuestionFourAnswer')
            }
          } else {
            completed = false
          }
        } else {
          this.$delete(this.form,'onlineMonitorQuestionTwoAnswer')
          this.$delete(this.form,'onlineMonitorQuestionThreeAnswer')
          this.$delete(this.form,'onlineMonitorQuestionFourAnswer')
          this.$delete(this.form,'onlineMonitorQuestionFiveAnswer')
          this.$delete(this.form,'onlineMonitorQuestionSixAnswer')
          this.delRemarks('onlineMonitorQuestionTwoAnswer')
          this.delRemarks('onlineMonitorQuestionThreeAnswer')
          this.delRemarks('onlineMonitorQuestionFourAnswer')
          this.delRemarks('onlineMonitorQuestionFiveAnswer')
          this.delRemarks('onlineMonitorQuestionSixAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedODS(){
      let completed = true
      if (this.form.odsModuleQuestionOneAnswer) {
        if (this.form.odsModuleQuestionOneAnswer==='涉及') {
          if (this.form.odsModuleQuestionTwoAnswer?.length>0 && this.form.odsModuleQuestionThreeAnswer?.length>0 && this.form.odsModuleQuestionFourAnswer && this.form.odsModuleQuestionFiveAnswer && this.form.odsModuleQuestionSixAnswer) {
            if (this.form.odsModuleQuestionThreeAnswer.some(val => val === '其他')) {
              if (!this.isStringExist(this.form.odsModuleQuestionThreeAnswerOther)) completed = false
            } else {
              this.$delete(this.form,'odsModuleQuestionThreeAnswerOther')
            }
          } else {
            completed = false
          }
        } else {
          this.$delete(this.form,'odsModuleQuestionTwoAnswer')
          this.$delete(this.form,'odsModuleQuestionThreeAnswer')
          this.$delete(this.form,'odsModuleQuestionFourAnswer')
          this.$delete(this.form,'odsModuleQuestionFiveAnswer')
          this.$delete(this.form,'odsModuleQuestionSixAnswer')
          this.$delete(this.form,'odsModuleQuestionThreeAnswerOther')
          this.delRemarks('odsModuleQuestionTwoAnswer')
          this.delRemarks('odsModuleQuestionThreeAnswer')
          this.delRemarks('odsModuleQuestionFourAnswer')
          this.delRemarks('odsModuleQuestionFiveAnswer')
          this.delRemarks('odsModuleQuestionSixAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedTen(){
      let completed = true
      if (this.form.suddenEnvQuestionOneAnswer) {
        if (this.form.suddenEnvQuestionOneAnswer==='涉及') {
          if (this.form.suddenEnvQuestionTwoAnswer && this.form.suddenEnvQuestionFourAnswer && this.form.suddenEnvQuestionFiveAnswer && this.form.suddenEnvQuestionSixAnswer) {
            if (this.form.suddenEnvQuestionTwoAnswer!=='未备案') {
              if (!this.isStringExist(this.form.suddenEnvQuestionThreeAnswer) || !this.isStringExist(this.form.suddenEnvQuestionSevenAnswer) || !this.isStringExist(this.form.suddenEnvQuestionEightAnswer)) completed = false;
            } else {
              this.$delete(this.form,'suddenEnvQuestionThreeAnswer')
              this.$delete(this.form,'suddenEnvQuestionSevenAnswer')
              this.$delete(this.form,'suddenEnvQuestionEightAnswer')
              this.delRemarks('suddenEnvQuestionThreeAnswer')
              this.delRemarks('suddenEnvQuestionSevenAnswer')
              this.delRemarks('suddenEnvQuestionEightAnswer')
            }
          } else {
            completed = false
          }
        } else {
          this.$delete(this.form,'suddenEnvQuestionTwoAnswer')
          this.$delete(this.form,'suddenEnvQuestionThreeAnswer')
          this.$delete(this.form,'suddenEnvQuestionFourAnswer')
          this.$delete(this.form,'suddenEnvQuestionFiveAnswer')
          this.$delete(this.form,'suddenEnvQuestionSixAnswer')
          this.$delete(this.form,'suddenEnvQuestionSevenAnswer')
          this.$delete(this.form,'suddenEnvQuestionEightAnswer')
          this.delRemarks('suddenEnvQuestionTwoAnswer')
          this.delRemarks('suddenEnvQuestionThreeAnswer')
          this.delRemarks('suddenEnvQuestionFourAnswer')
          this.delRemarks('suddenEnvQuestionFiveAnswer')
          this.delRemarks('suddenEnvQuestionSixAnswer')
          this.delRemarks('suddenEnvQuestionSevenAnswer')
          this.delRemarks('suddenEnvQuestionEightAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedEleventh(){
      let completed = true
      if (this.form.boilerSaidQuestionOneAnswer && this.form.boilerSaidQuestionTwoAnswer) {
        if (this.form.boilerSaidQuestionOneAnswer==='涉及') {
          if (this.form.boilerSaidQuestionThreeAnswer?.length>0) {
            if (this.form.boilerSaidQuestionThreeAnswer.some(val => val === '锅炉')){
              if (this.form.boilerSaidQuestionFourAnswer && this.isStringExist(this.form.boilerSaidQuestionFiveAnswer)) {
                if (!this.form.boilerSaidQuestionFourAnswer.split(',').some(val => val.includes('其他'))) {
                  this.$delete(this.form,'boilerSaidQuestionFourAnswerOther')
                }
              } else {
                completed = false
              }
            } else {
              this.$delete(this.form,'boilerSaidQuestionFourAnswer')
              this.$delete(this.form,'boilerSaidQuestionFourAnswerOther')
              this.$delete(this.form,'boilerSaidQuestionFiveAnswer')
              this.delRemarks('boilerSaidQuestionFourAnswer')
              this.delRemarks('boilerSaidQuestionFiveAnswer')
            }
            if (this.form.boilerSaidQuestionThreeAnswer.some(val => val === '炉窑')){
              if (this.form.boilerSaidQuestionSixAnswer && this.form.boilerSaidQuestionSevenAnswer?.length>0) {
                if (!this.form.boilerSaidQuestionSixAnswer.split(',').some(val => val.includes('其他'))) {
                  this.$delete(this.form,'boilerSaidQuestionSixAnswerOther')
                }
                if (!this.form.boilerSaidQuestionSevenAnswer.some(val => val === '其他')) {
                  this.$delete(this.form,'boilerSaidQuestionSevenAnswerOther')
                }
              } else {
                completed = false
              }
            } else {
              this.$delete(this.form,'boilerSaidQuestionSixAnswer')
              this.$delete(this.form,'boilerSaidQuestionSixAnswerOther')
              this.$delete(this.form,'boilerSaidQuestionSevenAnswer')
              this.$delete(this.form,'boilerSaidQuestionSevenAnswerOther')
              this.delRemarks('boilerSaidQuestionSixAnswer')
              this.delRemarks('boilerSaidQuestionSevenAnswer')
            }
          } else {
            completed = false
          }
        } else {
          this.$delete(this.form,'boilerSaidQuestionThreeAnswer')
          this.$delete(this.form,'boilerSaidQuestionFourAnswer')
          this.$delete(this.form,'boilerSaidQuestionFourAnswerOther')
          this.$delete(this.form,'boilerSaidQuestionFiveAnswer')
          this.$delete(this.form,'boilerSaidQuestionSixAnswer')
          this.$delete(this.form,'boilerSaidQuestionSixAnswerOther')
          this.$delete(this.form,'boilerSaidQuestionSevenAnswer')
          this.$delete(this.form,'boilerSaidQuestionSevenAnswerOther')
          this.delRemarks('boilerSaidQuestionThreeAnswer')
          this.delRemarks('boilerSaidQuestionFourAnswer')
          this.delRemarks('boilerSaidQuestionFiveAnswer')
          this.delRemarks('boilerSaidQuestionSixAnswer')
          this.delRemarks('boilerSaidQuestionSevenAnswer')
        }
        if (this.form.boilerSaidQuestionTwoAnswer==='涉及') {
          if (!this.form.boilerSaidQuestionEightAnswer?.length>0 || !this.form.boilerSaidQuestionNineAnswer) completed = false
        } else {
          this.$delete(this.form,'boilerSaidQuestionEightAnswer')
          this.$delete(this.form,'boilerSaidQuestionNineAnswer')
          this.delRemarks('boilerSaidQuestionEightAnswer')
          this.delRemarks('boilerSaidQuestionNineAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    checkCompletedDecember(){
      let completed = true
      if (this.form.penaltyQuestionOneAnswer) {
        if (this.form.penaltyQuestionOneAnswer==='涉及') {
          if (!this.form.penaltyQuestionThreeAnswer || !this.isStringExist(this.form.penaltyQuestionTwoAnswer)) completed = false
        } else {
          this.$delete(this.form,'penaltyQuestionTwoAnswer')
          this.$delete(this.form,'penaltyQuestionThreeAnswer')
          this.delRemarks('penaltyQuestionTwoAnswer')
          this.delRemarks('penaltyQuestionThreeAnswer')
        }
      } else {
        completed = false
      }
      return completed
    },
    //判断是否存在（字符串）
    isStringExist(str) {
      return typeof str === 'string' && str?.trim().length > 0;
    },
    //跳转未完成的检查项
    handleUncompletedInspections(checkItemName){
      this.popup.show = false
      this.tabVale = checkItemName
    }
  },
  async mounted() {
    this.options.canvasHeight = window.innerHeight-70
    this.options.canvasWidth = window.innerWidth-60
    this.companyId = localStorage.getItem('companyId');
    this.companyName = localStorage.getItem('companyName');
    this.$set(this.form,'companyId',this.companyId)
    this.form.companyAlias = this.companyName;
    this.$set(this.form,'isProblem','否')
    const address = localStorage.getItem('companyAddress');
    const industryName = localStorage.getItem('industryName');
    this.form.companyAddress = address && address!=='null'?address:'';
    this.form.industryName = industryName && industryName!=='null'?industryName:'';
    this.addRemarks('isProblem')
    await this.initCache()
    this.industryList = await $.get('dict/getCodeNameByTypeMobile/HYML/HYXL')
    this.opened();
  }
}

</script>

<style lang="less" scoped>
/deep/.amap-geolocation-con,/deep/.amap-geo{
  z-index: 8888 !important;
}
.sign-text{
  text-align: center;
  width: 200px;
  font-size: 44px;
  background-color: rgba(27, 117, 246, 0.9);
  border-radius: 16px;
  color: #fff;
  position: fixed;
  top: 89.8%;
  left: -50px;
  transform:rotate(90deg);
  -ms-transform:rotate(90deg);
  /* IE 9 */
  -moz-transform:rotate(90deg);
  /* Firefox */
  -webkit-transform:rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform:rotate(90deg);
  /* Opera */
}
.sign-text1{
  text-align: center;
  width: 200px;
  font-size: 44px;
  background-color: #e1e1e1;
  border-radius: 16px;
  color: #000000;
  position: fixed;
  top: 69.8%;
  left: -50px;
  transform:rotate(90deg);
  -ms-transform:rotate(90deg);
  /* IE 9 */
  -moz-transform:rotate(90deg);
  /* Firefox */
  -webkit-transform:rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform:rotate(90deg);
  /* Opera */
}
.sign-text2{
  text-align: center;
  width: 290px;
  font-size: 28px;
  color: #1C75F6;
  position: fixed;
  top: 17.5%;
  left: -90px;
  transform:rotate(90deg);
  -ms-transform:rotate(90deg);
  /* IE 9 */
  -moz-transform:rotate(90deg);
  /* Firefox */
  -webkit-transform:rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform:rotate(90deg);
  /* Opera */
}
.toolbar {
  background-color: #FFFFFF;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  padding: 10px 30px 30px 30px;
  box-shadow: #7893ff45 0 0 35px;
}
.sign-canvas{
  position: fixed;
  left: 100px;
  border: 1px solid #c5c5c5;
}
.signBtn {
  width: 250px;
  height: 65px;
  line-height: 65px;
  border-radius: 10px;
}
.signBtn2x {
  width: 280px;
  height: 65px;
  line-height: 65px;
  border-radius: 10px;
}
.signBtn2 {
  width: 640px;
  height: 65px;
  line-height: 65px;
  border-radius: 10px;
}
.title {
  padding: 10px 10px;
}
.uploadArea {
  background-color: #FFFFFF;
  text-align: center;
  padding: 30px;
}
.esigns {
  padding: 110px 40px 40px 40px;
}
.signModal {
  border: 1px solid #B3B3B3;
  margin-top: 20px;
}
.btn {
  display: flex;
  justify-content: space-around;
  margin-top: 30px;
}
/* 自定义布局样式 */
.custom-field {
  display: flex;
  flex-direction: column;
  gap: 8px; /* 添加间距 */
}
/* 检查项备注样式 */
/deep/.custom-field-remarks .van-field__control {
  flex-direction: column;
  align-items: start;
  gap: 8px; /* 控制两行间距 */
}
.custom-label {
  display: flex;
  flex-direction: column;
  font-size: 24px;
  color: #666666;
  margin-bottom: 8px;
}
.custom-label2 {
  display: flex;
  width: auto;
  gap: 8px;
  align-items: center;
  font-size: 28px;
  color: #333;
  justify-content: space-between;
}
.title-icon {
  flex-shrink: 0;
  vertical-align: middle;
}
/* 调整输入区域样式 */
 /deep/.van-field__body {
  width: 100%;
}

/deep/.select-industry-popup{
  z-index: 9999 !important;
}
#selectIndustryBar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-color: #F7F7F7;
}
/deep/.selectIndustryBarTitle .van-nav-bar__title {
  color: #353535;
}
.search-style .van-search__content{
   border-radius: 5px;
   background-color: #f3f1f1;
 }
/* 选中状态背景色 */
.selected-cell {
  background-color: #f5f5f5 !important;
}
/* 调整√图标位置 */
.check-icon {
  margin-left: 8px;
  vertical-align: middle;
}
/* 取消默认点击高亮 */
.van-cell:active {
  background-color: unset !important;
}
/deep/.collapse-item-content .van-collapse-item__content {
  padding: 6px;
  color: #969799;
  font-size: 13px;
  line-height: 1.5;
  background-color: #fff;
}
.van-collapse-item {
  margin-top: 10px; /* 自定义间距值 */
}
.collapse-item-title{
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 31px;
  white-space: nowrap;
}
.fixed-text {
  color: #666;
  user-select: none; /* 禁止选中固定文本 */
}
.radio-item {
  margin: 10px 20px 0 0
}
.radio-item-other {
  margin: 10px 5px 0 0
}
.checkbox-item {
  margin: 5px 5px 0 0
}
.checkbox-item-span {
  margin-right: 15px
}
/*答题完成情况选择项样式*/
/deep/.grid-item-popup .van-grid-item__content {
  padding: 0 !important;
}
.grid-item-icon {
  border-radius: 50%;
  display: grid;
  place-items: center;
}

/deep/ .data-picker-color .van-ellipsis {
  color: #000 !important;
}
</style>
